<template>
  <div class="user-management-page" role="main" aria-label="User Management Page">
    <!-- Main Container -->
    <v-container fluid class="user-management-container" aria-labelledby="page-title">
      <v-card class="main-content-card" elevation="0">
        <!-- <v-card-text> --- IGNORE --->
        <!-- Page Header Section -->
        <section class="page-header-section mb-6" aria-label="Page Header">
          <div class="page-header-content">
            <div class="page-title-wrapper">
              <h1 id="page-title" class="page-title" tabindex="0">
                Portal User Management
              </h1>
            </div>

            <!-- Action Buttons Group -->
            <div class="header-actions-group" role="toolbar" aria-label="User management actions">
              <v-btn id="button-downloadtemplate-usermanagement" class="action-btn-template" variant="outlined"
                size="large" rounded="lg" @click="flagTemplate = true" aria-label="Download template file">
                <v-img :src="images.downloadImg" alt="Template" class="template-icon"> </v-img>
                <span class="btn-label">Template</span>
                <v-tooltip activator="parent" location="top">
                  Download Template
                </v-tooltip>
              </v-btn>

              <!-- Import Button -->
              <v-btn id="button-import-usermanagement" class="action-btn-import" variant="outlined" size="large"
                rounded="lg" @click="triggerFileUpload" aria-label="Import users from file">
                <v-img :src="images.templateImg" alt="Template" class="template-icon"> </v-img>
                <span class="btn-label">Import</span>
                <v-tooltip activator="parent" location="top">
                  Import File
                </v-tooltip>
              </v-btn>

              <!-- Hidden File Upload Component -->
              <DragDropFile ref="fileUploader" :dialog="true" :DragDrop="false" :ShowListFile="false" :accept="accept"
                @filesUploaded="processUpload($event)" :allowType="[]" class="d-none" aria-hidden="true" />

              <!-- Add New User Button -->
              <v-btn id="button-add-usermanagement" class="action-btn-add" variant="elevated" size="large" rounded="lg"
                @click="
                  Adddialog = true;
                formHasErrors = false;
                mailcheck = false;
                phonecheck = false;
                checkLengthPassword = true;
                checkLowercaseLetter = true;
                checkUppercaseLetter = true;
                checkNumber = true;
                checkSpecialCharacter = true;
                checkPasswordMatch = true;
                user.password = null;
                user.confirmpassword = null;
                " aria-label="Add new user">
                <v-icon start size="20">mdi-plus</v-icon>
                <span class="btn-label">{{ $t("add") }}</span>
                <v-tooltip activator="parent" location="top">
                  Add New User
                </v-tooltip>
              </v-btn>
            </div>
          </div>
        </section>

        <!-- Search Panel Section -->
        <section class="search-panel-section" aria-label="Search and Filter Users">
          <v-row class="align-center" no-gutters>
            <!-- Username Search Field -->
            <v-col cols="12" md="4" class="pr-md-3 mb-3 mb-md-0">
              <div class="custom-search-input-wrapper-full">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="username-field-search-usermanagement" type="text" placeholder="Username"
                    class="custom-search-input" v-model="username" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="username ? '' : 'color: transparent !important;'"
                    @click="username = ''">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
            </v-col>

            <!-- Email Search Field -->
            <v-col cols="12" md="4" class="pr-md-3 mb-3 mb-md-0">
              <div class="custom-search-input-wrapper-full">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="email-field-search-usermanagement" type="text" placeholder="Email"
                    class="custom-search-input" v-model="email" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="email ? '' : 'color: transparent !important;'"
                    @click="email = ''">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
            </v-col>

            <!-- Role Filter -->
            <v-col cols="12" md="4">
              <div class="role-filter-wrapper d-flex align-center justify-space-between w-100">
                <!-- Left side -->
                <div class="d-flex align-center ga-1">
                  <!-- Search Button Column -->
                  <div class="d-flex justify-center justify-md-start">
                    <v-btn id="button-search-usermanagement" class="search-btn-circular" icon size="40"
                      @click="Search" aria-label="Execute search">
                      <v-icon size="22" color="white">mdi-magnify</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Search Users
                      </v-tooltip>
                    </v-btn>
                  </div>
                  <div class="vertical-divider mx-1"></div>

                  <span class="filter-label">{{ selectedRoleFilter === null ? 'All Roles' :
                    getRoleFilterLabel(selectedRoleFilter) }}</span>
                  <span class="text-gray-darken-1">({{ filteredRoleCount }})</span>
                </div>

                <!-- Right side: Filter Button with Dropdown Menu -->
                <div class="d-flex align-center ga-1">
                  <v-btn v-if="selectedRoleFilter !== null" id="button-clearfilters-usermanagement"
                    variant="text" color="#3859D0" @click="clearFilters" aria-label="Clear all filters" class="clear-filters-btn">
                    Clear Filters
                    <v-tooltip activator="parent" location="top">
                      Reset search and role filters
                    </v-tooltip>
                  </v-btn>

                  <v-menu v-model="roleFilterMenuOpen" :close-on-content-click="false" location="bottom end"
                    offset="8">
                    <template v-slot:activator="{ props }">
                      <v-btn id="button-filter-role-user_management" icon size="40" class="filter-icon-btn-circular"
                        v-bind="props" aria-label="Apply user role filter">
                        <v-icon size="30" color="#872612">mdi-filter-variant</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Apply User Role Filter
                        </v-tooltip>
                      </v-btn>
                    </template>

                    <v-card class="role-filter-dropdown" min-width="200">
                      <v-list class="py-0 filter-role-list">
                        <v-list-item v-for="option in roleFilterOptions"
                          :key="option.value === null ? 'all' : option.value"
                          @click="tempSelectedRole = option.value"
                          :class="{ 'selected-role-item': tempSelectedRole === option.value }"
                          class="role-filter-item">
                          <v-list-item-title class="role-filter-item-title">
                            {{ option.label }}
                          </v-list-item-title>
                          <template v-slot:append>
                            <v-icon v-if="tempSelectedRole === option.value" color="#C32E0E" size="20">mdi-check</v-icon>
                          </template>
                        </v-list-item>
                      </v-list>

                      <v-divider></v-divider>

                      <!-- Apply Button -->
                      <div class="pa-3">
                        <v-btn block class="apply-filter-btn" @click="showApplyFilterConfirmation">
                          Apply
                        </v-btn>
                      </div>
                    </v-card>
                  </v-menu>
                </div>
              </div>
            </v-col>

          </v-row>
        </section>

        <!-- Data Table Section -->
        <v-data-table-server :items="filteredUsers" :items-per-page="itemsPerPage" :items-length="searchTotalTable"
          v-model:options="options" :headers="headers" :loading="loadingTable" class="rounded-xl customtable" hover
          aria-label="Users list table">
          <!-- Custom Table Rows -->
          <template v-slot:item="{ item }">
            <tr class="table-row" :aria-label="`User ${item.username}`">
              <td class="table-cell cell-number text-center" role="cell">
                {{ item.number }}
              </td>
              <td class="table-cell cell-username" role="cell">
                {{ item.username }}
              </td>
              <td class="table-cell cell-email" role="cell">
                {{ item.email }}
              </td>
              <td class="table-cell cell-phone" role="cell">
                {{ item.mobile }}
              </td>
              <td class="table-cell cell-name" role="cell">
                {{ item.fullName }}
              </td>
              <td class="table-cell cell-role" role="cell">
                {{ getRoleName(item.roleId) }}
              </td>

              <!-- Manage/Actions Column -->
              <td class="table-cell cell-actions text-center" role="cell" style="padding: 12px;">
                <div class="action-container" role="group" aria-label="Row actions">
                  <div class="action-group-user">
                    <!-- Edit Button -->
                    <v-btn id="button-edit-popupedit-usermanagement"
                      v-if="item.roleId != 0 || (item.roleId == 0 && roleId == '0')" variant="text"
                      density="comfortable" class="action-btn edit-btn" icon @click="EditUser(item)"
                      :aria-label="`Edit user ${item.username}`">
                      <img :src="images.edit" alt="Edit" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        Edit
                      </v-tooltip>
                    </v-btn>

                    <!-- Delete Button -->
                    <v-btn id="button-delete-popupedit-usermanagement" v-if="
                      item.userId != 1 &&
                      !isOwnerUserType(item.userType)
                    " variant="text" density="comfortable" class="action-btn delete-btn" icon @click="DeleteUser(item)"
                      :aria-label="`Delete user ${item.username}`">
                      <img :src="images.delete" alt="Delete" style="width: 25px; height: 25px;" />
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
          </template>

          <!-- Table Footer with Total Results -->
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items-per-page-options="[10, 20, 50]"
                v-model:items-per-page="itemsPerPage"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <!-- EditUserDialog -->
    <v-dialog v-model="Editdialog" max-width="900px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">Edit User</h2>
              <p class="dialog-subtitle">Edit user account information</p>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="edit-user-content">
          <div class="edit-user-container">
            <!-- Basic Information Section -->
            <div class="border-section-wrapper mb-7">
              <div class="basic-info-container">
                <img :src="images.basicInfoIcon" alt="Basic Info" class="basic-info-icon" />
                <span class="basic-info-text">Basic Information</span>
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div :class="['input-wrapper', { 'input-error-state': isEditFieldInvalid('username') }]">
                    <label class="input-label">
                      Username<span class="required-asterisk">*</span>
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div class="tooltip-content">
                          <div>The unique identifier the user will use to log in to the portal.This must be unique
                            across
                            all system users.</div>
                        </div>
                      </v-tooltip>
                    </label>
                    <v-text-field :label="$t('username')" :rules="[rules.required]" v-model="edit.username"
                      variant="outlined" density="compact" hide-details="auto" disabled class="modern-input"
                      :error="isEditFieldInvalid('username')">
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div :class="['input-wrapper', { 'input-error-state': isEditFieldInvalid('firstname') }]">
                    <label class="input-label">First Name <span class="required-asterisk">*</span></label>
                    <v-text-field id="firstname-field-popupedit-usermanagement" :label="$t('firstname')"
                      :rules="[rules.required]" v-model="edit.firstname" variant="outlined" density="compact"
                      hide-details="auto" placeholder="Enter first name" class="modern-input"
                      :error="isEditFieldInvalid('firstname')">
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div :class="['input-wrapper', { 'input-error-state': isEditFieldInvalid('lastname') }]">
                    <label class="input-label">Last Name <span class="required-asterisk">*</span></label>
                    <v-text-field id="lastname-field-popupedit-usermanagement" :label="$t('lastname')"
                      :rules="[rules.required]" v-model="edit.lastname" variant="outlined" density="compact"
                      hide-details="auto" placeholder="Enter last name" class="modern-input"
                      :error="isEditFieldInvalid('lastname')">
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div :class="['input-wrapper', { 'input-error-state': isEditFieldInvalid('email') }]">
                    <label class="input-label">Email <span class="required-asterisk">*</span></label>
                    <v-text-field :label="$t('email')" :rules="[rules.required, validateEmail(edit.email)]"
                      v-model="edit.email" variant="outlined" density="compact" hide-details="auto" disabled
                      placeholder="Enter email address" class="modern-input"
                      :error="isEditFieldInvalid('email')">
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Phone Number</label>
                    <v-text-field id="phonenumber-field-popupedit-usermanagement" :label="$t('phonenumber')"
                      v-model="edit.phone" v-mask="mask" variant="outlined" density="compact" hide-details="auto"
                      placeholder="Enter phone number" class="modern-input">
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Role & Permissions Section -->
            <div class="role-permissions-wrapper">
              <div class="section-title">
                <img :src="images.shieldIcon" alt="Role & Permissions" class="image-icon-style" />
                Role & Permissions
              </div>
              
              <v-row class="form-row">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label">
                      User Role <span class="required-asterisk">*</span>
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div class="tooltip-content">
                          Defines the permission level and access rights for this user.
                        </div>
                      </v-tooltip>
                    </label>
                    <div class="role-selection-container-new">
                      <v-radio-group id="role-radiogroup-popupedit-usermanagement" v-model="edit.roleId"
                        class="role-radio-group-new" :disabled="isEditRoleLocked" hide-details>
                        <div class="role-cards-grid-new">
                          <!-- Super Admin Card -->
                          <div v-show="roleId == '0'" class="role-card-new" :class="{
                            selected: edit.roleId === 0,
                            disabled: isEditRoleLocked,
                          }" @click="setEditRole(0)">
                            <div class="role-card-checkbox">
                              <v-radio :value="0" class="role-radio-new"
                                :disabled="isEditRoleLocked"></v-radio>
                            </div>
                            <div class="role-card-icon">
                              <img :src="edit.roleId === 0 ? images.superAdminRedIcon : images.superAdminIcon" alt="Super Admin" class="role-icon-svg" />
                            </div>
                            <div class="role-card-label">{{ $t("superAdmin") }}</div>
                            <v-tooltip activator="parent" location="top" max-width="300">
                              <div class="tooltip-content">
                                Has full system access, including user roles, setting, and configurations.
                              </div>
                            </v-tooltip>
                          </div>

                          <!-- Admin Card -->
                          <div class="role-card-new" :class="{ selected: edit.roleId === 1, disabled: isEditRoleLocked }"
                            @click="setEditRole(1)">
                            <div class="role-card-checkbox">
                              <v-radio :value="1" class="role-radio-new" :disabled="isEditRoleLocked"></v-radio>
                            </div>
                            <div class="role-card-icon">
                              <img :src="edit.roleId === 1 ? images.adminRedIcon : images.adminIcon" alt="Admin" class="role-icon-svg" />
                            </div>
                            <div class="role-card-label">{{ $t("admin") }}</div>
                            <v-tooltip activator="parent" location="top" max-width="300">
                              <div class="tooltip-content">
                                Manage users, models, and project settings but with limited system control.
                              </div>
                            </v-tooltip>
                          </div>

                          <!-- General User Card -->
                          <div class="role-card-new" :class="{ selected: edit.roleId === 2, disabled: isEditRoleLocked }"
                            @click="setEditRole(2)">
                            <div class="role-card-checkbox">
                              <v-radio :value="2" class="role-radio-new" :disabled="isEditRoleLocked"></v-radio>
                            </div>
                            <div class="role-card-icon">
                              <img :src="edit.roleId === 2 ? images.userRedIcon : images.userIcon" alt="User" class="role-icon-svg" />
                            </div>
                            <div class="role-card-label">{{ $t("generalUsers") }}</div>
                            <v-tooltip activator="parent" location="top" max-width="300">
                              <div class="tooltip-content">
                                Has access assigned models and projects within their permission scope.
                              </div>
                            </v-tooltip>
                          </div>

                          <!-- Operator Card -->
                          <div class="role-card-new" :class="{ selected: edit.roleId === 6, disabled: isEditRoleLocked }"
                            @click="setEditRole(6)">
                            <div class="role-card-checkbox">
                              <v-radio :value="6" class="role-radio-new" :disabled="isEditRoleLocked"></v-radio>
                            </div>
                            <div class="role-card-icon">
                              <img :src="edit.roleId === 6 ? images.operatorRedIcon : images.operatorIcon" alt="Operator" class="role-icon-svg" />
                            </div>
                            <div class="role-card-label">{{ $t("_Operator") }}</div>
                            <v-tooltip activator="parent" location="top" max-width="300">
                              <div class="tooltip-content">
                                Handle daily chat operations, monitoring, and responding to user interactions.
                              </div>
                            </v-tooltip>
                          </div>
                        </div>
                      </v-radio-group>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Model Selection for General Users -->
              <v-row class="form-row" v-show="edit.roleId == 2 || edit.roleId == 6">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label">
                      Available Models
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                        </template>
                        <div class="tooltip-content">Choose which AI models are accessible for this user.</div>
                      </v-tooltip>
                    </label>
                    <v-autocomplete id="model-field-popupedit-usermanagement" :items="listDDModel"
                      item-title="name" item-value="modelDisplayID" variant="outlined" density="compact" multiple
                      clearable hide-details="auto" placeholder="Select Models"
                      v-model="edit.model" class="modern-input role-autocomplete model-autocomplete"
                      :menu-props="{ closeOnContentClick: false, closeOnOutsideClick: false }"
                      @update:modelValue="(value) => handleModelSelection('edit', value)">
                      <template #prepend-item>
                        <v-list-item
                          class="model-option-item model-all-option"
                          :class="{ 'model-all-option--active': isAllModelsSelected(edit.model), 'model-all-option--disabled': !listDDModel.length }"
                          density="compact"
                          @mousedown.prevent
                          @click.stop="toggleAllModels('edit')"
                        >
                          <template #prepend>
                            <v-checkbox-btn
                              class="model-option-checkbox"
                              :model-value="isAllModelsSelected(edit.model)"
                              color="#C30000"
                              :ripple="false"
                              :disabled="!listDDModel.length"
                              @click.stop="toggleAllModels('edit')"
                            ></v-checkbox-btn>
                          </template>
                          <template #title>
                            <div class="model-all-title">
                              <span class="model-all-option__label">All Model</span>
                              <v-tooltip location="top">
                                <template #activator="{ props }">
                                  <v-icon v-bind="props" size="18" class="model-info-icon">mdi-information-outline</v-icon>
                                </template>
                                <span>All available models will be included in this group.</span>
                              </v-tooltip>
                            </div>
                          </template>
                        </v-list-item>
                        <v-divider class="model-all-divider"></v-divider>
                      </template>

                      <template #item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'model-edit-usermanagement-option-' + index"
                          class="model-option-item" :class="{ 'model-option-item--selected': isModelSelected('edit', item.raw.modelDisplayID) }"
                          @click="props.onClick" @mousedown.prevent>
                          <template #prepend>
                            <v-checkbox-btn class="model-option-checkbox" :model-value="isModelSelected('edit', item.raw.modelDisplayID)"
                              color="#C30000" :ripple="false" @click.stop="props.onClick"></v-checkbox-btn>
                          </template>
                          <template #title>
                            <span class="model-option-title">{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>

                      <template #selection="{ item, index }">
                        <!-- When all models selected, show single "All Model" label only for first item -->
                        <span v-if="shouldCollapseModelChips(edit.model) && index === 0" class="model-all-selected-label">
                          <!-- <v-icon size="16" color="#C30000" class="mr-1">mdi-check-all</v-icon> -->
                          All Model
                          <v-tooltip location="top">
                            <template #activator="{ props }">
                              <v-icon v-bind="props" size="18" class="model-info-icon">mdi-information-outline</v-icon>
                            </template>
                            <span>All available models will be included in this group.</span>
                          </v-tooltip>
                        </span>
                        <!-- When NOT all models selected, show chips with limit -->
                        <template v-else-if="!shouldCollapseModelChips(edit.model)">
                          <v-chip v-if="index < modelChipDisplayLimit" class="model-chip" size="small" closable
                            @click:close="onModelChipClose('edit', item.value)">
                            <template #close>x</template>
                            {{ item.title }}
                          </v-chip>
                          <v-chip v-else-if="index === modelChipDisplayLimit && hasHiddenModelChips(edit.model)" class="model-chip more-chip" size="small">
                            {{ getHiddenModelChipLabel(edit.model) }}
                          </v-chip>
                        </template>
                        <!-- Hide all other chips when all models are selected (index > 0) -->
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row v-show="edit.roleId == 2 || edit.roleId == 6">
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">
                      Document
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                        </template>
                        <div class="tooltip-content">Manage or link documents used for training, responses, or knowledge base.</div>
                      </v-tooltip>
                    </label>
                    <v-autocomplete id="document-autocomplete-edit-usermanagement" :items="listDDDocument"
                      v-model="edit.vectordbName" item-title="name" item-value="name" variant="outlined"
                      density="compact" multiple chips closable-chips clearable hide-details="auto"
                      placeholder="Select Documents" class="modern-input role-autocomplete">
                      <template v-slot:chip="{ props, item }">
                        <v-chip v-bind="props" class="custom-chip">
                          {{ item.title }}
                          <span class="chip-close-divider">|</span>
                          <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'document-edit-usermanagement-option-' + index"
                          :value="item.raw.name">
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">
                      Database Integration
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                        </template>
                        <div class="tooltip-content">Connect your system database to enable data retrieval.</div>
                      </v-tooltip>
                    </label>
                    <v-autocomplete id="data-integration-autocomplete-edit-usermanagement"
                      :items="listDDDataIntegration" v-model="edit.dataIntegrationID" item-title="dataName"
                      item-value="id" variant="outlined" density="compact" multiple chips closable-chips clearable
                      hide-details="auto" placeholder="Select Database Integration" class="modern-input role-autocomplete">
                      <template v-slot:chip="{ props, item }">
                        <v-chip v-bind="props" class="custom-chip">
                          {{ item.title }}
                          <span class="chip-close-divider">|</span>
                          <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'dataintegration-edit-usermanagement-option-' + index"
                          :value="item.raw.name">
                          <template v-slot:title>
                            <span>{{ item.raw.dataName }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row v-show="edit.roleId == 2 || edit.roleId == 6">
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">
                      Product Group Name
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                        </template>
                        <div class="tooltip-content">Specify the group for related products.</div>
                      </v-tooltip>
                    </label>
                    <v-autocomplete id="product-autocomplete-edit-usermanagement" :items="listDDProductGroup"
                      v-model="edit.productGroupID" item-title="productGroupName" item-value="productGroupID"
                      variant="outlined" density="compact" multiple chips closable-chips clearable hide-details="auto"
                      placeholder="Select Product Group Name" class="modern-input role-autocomplete">
                      <template v-slot:chip="{ props, item }">
                        <v-chip v-bind="props" class="custom-chip">
                          {{ item.title }}
                          <span class="chip-close-divider">|</span>
                          <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'product-edit-usermanagement-option-' + index"
                          :value="item.raw.name">
                          <template v-slot:title>
                            <span>{{ item.raw.productGroupName }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">
                      Intent Group Name
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                        </template>
                        <div class="tooltip-content">Define a group of intents used to organize chatbot responses.</div>
                      </v-tooltip>
                    </label>
                    <v-autocomplete id="intentgroup-autocomplete-edit-usermanagement" :items="listDDIntentGroup"
                      v-model="edit.intentGroupID" item-title="name" item-value="id" variant="outlined"
                      density="compact" multiple chips closable-chips clearable hide-details="auto"
                      placeholder="Select Intent Group Name" class="modern-input role-autocomplete">
                      <template v-slot:chip="{ props, item }">
                        <v-chip v-bind="props" class="custom-chip">
                          {{ item.title }}
                          <span class="chip-close-divider">|</span>
                          <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'intentgroup-edit-usermanagement-option-' + index"
                          :value="item.raw.name">
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <!-- Flows and Account Status Row -->
              <v-row class="form-row" v-show="edit.roleId == 2 || edit.roleId == 6">
                <v-col cols="6">
                  <div class="input-wrapper">
                    <label class="input-label">
                      Flows
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                        </template>
                        <div class="tooltip-content">Configure conversation flows to control chatbot logic and user paths.</div>
                      </v-tooltip>
                    </label>
                    <v-autocomplete id="flow-autocomplete-edit-usermanagement" :items="listDDFlowGroup"
                      v-model="edit.flowGroupID" item-title="name" item-value="flowGroupID" variant="outlined"
                      density="compact" multiple chips closable-chips clearable hide-details="auto"
                      placeholder="Select Intent Group Name" class="modern-input role-autocomplete">
                      <template v-slot:chip="{ props, item }">
                        <v-chip v-bind="props" class="custom-chip">
                          {{ item.title }}
                          <span class="chip-close-divider">|</span>
                          <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                        </v-chip>
                      </template>
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item v-bind="props" :id="'flow-edit-usermanagement-option-' + index"
                          :value="item.raw.name">
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="account-status-container">
                    <div class="account-status-left">
                      <div class="account-status-label-row">
                        <span class="account-status-label">Account Status</span>
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                          </template>
                          <div class="tooltip-content">Indicates whether the user account is locked or unlocked.</div>
                        </v-tooltip>
                      </div>
                      <div class="account-status-description">
                        {{ edit.lockStatus ? 'Account is Locked: User cannot access the system.' : 'Account is Unlocked: User can access the system.' }}
                      </div>
                    </div>
                    <div class="account-status-right">
                      <v-switch id="switch-lockstatus-popupedit-usermanagement" v-model="edit.lockStatus"
                        hide-details inset density="compact" :class="[
                          'publication-toggle',
                          edit.lockStatus
                            ? 'publication-toggle--active'
                            : 'publication-toggle--inactive'
                        ]"></v-switch>
                      <v-chip size="small" :color="edit.lockStatus ? '#C30000' : '#2ABF56'" variant="tonal" class="account-status-chip">
                        {{ edit.lockStatus ? $t("_Locked") : $t("_Unlocked") }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Account Status Row for non-operator/user roles -->
              <v-row class="form-row" v-show="edit.roleId != 2 && edit.roleId != 6">
                <v-col cols="6">
                  <div class="account-status-container">
                    <div class="account-status-left">
                      <div class="account-status-label-row">
                        <span class="account-status-label">Account Status</span>
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                          </template>
                          <div class="tooltip-content">Indicates whether the user account is locked or unlocked.</div>
                        </v-tooltip>
                      </div>
                      <div class="account-status-description">
                        {{ edit.lockStatus ? 'Account is Locked: User cannot access the system.' : 'Account is Unlocked: User can access the system.' }}
                      </div>
                    </div>
                    <div class="account-status-right">
                      <v-switch id="switch-lockstatus-popupedit-usermanagement-admin" v-model="edit.lockStatus"
                        hide-details inset density="compact" :class="[
                          'publication-toggle',
                          edit.lockStatus
                            ? 'publication-toggle--active'
                            : 'publication-toggle--inactive'
                        ]"></v-switch>
                      <v-chip size="small" :color="edit.lockStatus ? '#C30000' : '#2ABF56'" variant="tonal" class="account-status-chip">
                        {{ edit.lockStatus ? $t("_Locked") : $t("_Unlocked") }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-btn id="button-changepassword-popupedit-usermanagement" variant="outlined" color="#C32E0E" @click="
                changPasswordDialog = true;
              edit.password = '';
              edit.confirmpassword = '';
              checkLengthPassword = true;
              checkLowercaseLetter = true;
              checkUppercaseLetter = true;
              checkNumber = true;
              checkSpecialCharacter = true;
              checkPasswordMatch = true;
              " 
              class="dialog-action-btn px-4">
              <v-icon class="flip-right" start>mdi-lock-reset</v-icon>
              Change Password
              </v-btn>
            </div>
            <div class="actions-right">
              <v-btn id="button-close-popupedit-usermanagement" variant="outlined" color="grey"
                @click="closeedit()" class="dialog-action-btn cancel-btn">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn id="button-save-popupedit-usermanagement" variant="elevated" @click="UpdateUser"
                class="dialog-action-btn save-btn-edit">
                <v-img :src="images.newSaveImg" alt="Add User Dialog" class="image-icon-style"></v-img>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AddUserDialog -->
    <v-dialog ref="form" v-model="Adddialog" max-width="900px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">Add New User</h2>
              <p class="dialog-subtitle">
                Create a new user account with required information
              </p>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="add-user-content">
          <div class="user-container">
            <!-- Basic Information Section -->
            <div class="form-section basic-info-section">
              <div class="basic-info-container">
                <img :src="images.basicInfoIcon" alt="Basic Info" class="basic-info-icon" />
                <span class="basic-info-text">Basic Information</span>
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div :class="['input-wrapper', { 'input-error-state': isAddFieldInvalid('username') }]">
                    <label class="input-label">
                      Username <span class="required-asterisk">*</span>
                      <v-tooltip location="top start" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" size="16" class="info-icon">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div class="tooltip-content">
                          <div>The unique identifier the user will use to log in to the portal.This must be unique
                            across
                            all system users.</div>
                        </div>
                      </v-tooltip>
                    </label>
                    <v-text-field id="username-field-add-usermanagement" ref="username" v-model="user.username"
                      :rules="[rules.required]" variant="outlined" density="compact" hide-details="auto"
                      placeholder="Enter Username" class="modern-input"
                      :error="isAddFieldInvalid('username')">
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div :class="['input-wrapper', { 'input-error-state': isAddFieldInvalid('firstname') }]">
                    <label class="input-label">First Name <span class="required-asterisk">*</span></label>
                    <v-text-field id="firstname-field-add-usermanagement" ref="firstname" v-model="user.firstname"
                      :rules="[rules.required]" variant="outlined" density="compact" hide-details="auto"
                      placeholder="Enter First Name" class="modern-input"
                      :error="isAddFieldInvalid('firstname')">
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div :class="['input-wrapper', { 'input-error-state': isAddFieldInvalid('lastname') }]">
                    <label class="input-label">Last Name <span class="required-asterisk">*</span></label>
                    <v-text-field id="lastname-field-add-usermanagement" ref="lastname" v-model="user.lastname"
                      :rules="[rules.required]" variant="outlined" density="compact" hide-details="auto"
                      placeholder="Enter Last Name" class="modern-input"
                      :error="isAddFieldInvalid('lastname')">
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div :class="['input-wrapper', { 'input-error-state': isAddFieldInvalid('email') }]">
                    <label class="input-label">Email <span class="required-asterisk">*</span></label>
                    <v-text-field id="email-field-add-usermanagement" ref="email" v-model="user.email"
                      :rules="[rules.required, validateEmail(user.email)]" variant="outlined" density="compact"
                      hide-details="auto" placeholder="Enter Email Address" class="modern-input"
                      :error="isAddFieldInvalid('email')">
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Phone Number</label>
                    <v-text-field id="phonenumber-field-add-usermanagement" ref="phone" v-model="user.phone"
                      v-mask="mask" variant="outlined" density="compact" hide-details="auto"
                      placeholder="Enter Phone Number" class="modern-input">
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider></v-divider>

            <!-- Password Section -->
            <div class="form-section basic-info-section">
              <div class="section-title-password">
                <img :src="images.passwordIcon" alt="Password" class="image-icon-style" />
                Password Setup
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div :class="['input-wrapper', { 'input-error-state': isAddFieldInvalid('password') }]">
                    <label class="input-label">Password <span class="required-asterisk">*</span></label>
                    <v-text-field id="password-field-add-usermanagement" ref="password" v-model="user.password"
                      :rules="[rules.required]" :type="show1 ? 'text' : 'password'" variant="outlined" density="compact"
                      hide-details="auto" placeholder="Password" class="modern-input"
                      :error="isAddFieldInvalid('password')">
                      <template v-slot:append-inner>
                        <v-btn @click="show1 = !show1" icon variant="text" size="small" class="password-toggle">
                          <img :src="show1 ? images.unlockIcon : images.lockIcon" alt="toggle password" class="password-toggle-icon" />
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Requirements -->
                    <div class="password-requirements" v-if="user.password">
                      <div class="requirement-item" :class="{ valid: checkLengthPassword }">
                        <v-icon size="15" :color="checkLengthPassword ? '#2ABF56' : '#C30000'">
                          {{ checkLengthPassword ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>At least 8 characters</span>
                      </div>
                      <div class="requirement-item" :class="{ valid: checkLowercaseLetter }">
                        <v-icon size="15" :color="checkLowercaseLetter ? '#2ABF56' : '#C30000'">
                          {{ checkLowercaseLetter ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Lowercase letter</span>
                      </div>
                      <div class="requirement-item" :class="{ valid: checkUppercaseLetter }">
                        <v-icon size="15" :color="checkUppercaseLetter ? '#2ABF56' : '#C30000'">
                          {{ checkUppercaseLetter ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Uppercase letter</span>
                      </div>
                      <div class="requirement-item" :class="{ valid: checkNumber }">
                        <v-icon size="15" :color="checkNumber ? '#2ABF56' : '#C30000'">
                          {{ checkNumber ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Number</span>
                      </div>
                      <div class="requirement-item" :class="{ valid: checkSpecialCharacter }">
                        <v-icon size="15" :color="checkSpecialCharacter ? '#2ABF56' : '#C30000'">
                          {{
                            checkSpecialCharacter ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span>Special character</span>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div :class="['input-wrapper', { 'input-error-state': isAddFieldInvalid('confirmpassword') }]">
                    <label class="input-label">Confirm Password <span class="required-asterisk">*</span></label>
                    <v-text-field id="confirmpassword-field-add-usermanagement" ref="confirmpassword"
                      v-model="user.confirmpassword" :rules="[rules.required]" :type="show2 ? 'text' : 'password'"
                      variant="outlined" density="compact" hide-details="auto" placeholder="Confirm Password"
                      class="modern-input" :error="isAddFieldInvalid('confirmpassword')">
                      <template v-slot:append-inner>
                        <v-btn @click="show2 = !show2" icon variant="text" size="small" class="password-toggle">
                          <img :src="show2 ? images.unlockIcon : images.lockIcon" alt="toggle password" class="password-toggle-icon" />
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Match Indicator -->
                    <div class="password-match" v-if="user.confirmpassword">
                      <div class="requirement-item" :class="{ valid: checkPasswordMatch }">
                        <v-icon size="15" :color="checkPasswordMatch ? '#2ABF56' : '#C30000'">
                          {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Passwords match</span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Role & Permissions Section -->
            <div class="form-section">
              <div class="section-title">
                <img :src="images.shieldIcon" alt="Role & Permissions" class="image-icon-style" />
                Role & Permissions
              </div>
              
              <div class="role-permissions-wrapper">
                <v-row class="form-row">
                  <v-col cols="12">
                    <div class="input-wrapper">
                      <label class="input-label">
                        User Role <span class="required-asterisk">*</span>
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div class="tooltip-content">
                            Defines the permission level and access rights for this user.
                          </div>
                        </v-tooltip>
                      </label>
                      <div class="role-selection-container-new">
                        <v-radio-group id="role-radiogroup-add-usermanagement" v-model="user.roleId"
                          class="role-radio-group-new" hide-details>
                          <!-- New Role Cards Grid -->
                          <div class="role-cards-grid-new">
                            <!-- Super Admin Card -->
                            <div v-show="roleId == '0'" class="role-card-new" :class="{ selected: user.roleId === 0 }"
                              @click="user.roleId = 0">
                              <div class="role-card-checkbox">
                                <v-radio :value="0" class="role-radio-new"></v-radio>
                              </div>
                              <div class="role-card-icon">
                                <img :src="user.roleId === 0 ? images.superAdminRedIcon : images.superAdminIcon" alt="Super Admin" class="role-icon-svg" />
                              </div>
                              <div class="role-card-label">{{ $t("superAdmin") }}</div>
                              <v-tooltip activator="parent" location="top" max-width="300">
                                <div class="tooltip-content">
                                  Has full system access, including user roles, setting, and configurations.
                                </div>
                              </v-tooltip>
                            </div>

                            <!-- Admin Card -->
                            <div class="role-card-new" :class="{ selected: user.roleId === 1 }"
                              @click="user.roleId = 1">
                              <div class="role-card-checkbox">
                                <v-radio :value="1" class="role-radio-new"></v-radio>
                              </div>
                              <div class="role-card-icon">
                                <img :src="user.roleId === 1 ? images.adminRedIcon : images.adminIcon" alt="Admin" class="role-icon-svg" />
                              </div>
                              <div class="role-card-label">{{ $t("admin") }}</div>
                              <v-tooltip activator="parent" location="top" max-width="300">
                                <div class="tooltip-content">
                                  Manage users, models, and project settings but with limited system control.
                                </div>
                              </v-tooltip>
                            </div>

                            <!-- General User Card -->
                            <div class="role-card-new" :class="{ selected: user.roleId === 2 }"
                              @click="user.roleId = 2">
                              <div class="role-card-checkbox">
                                <v-radio :value="2" class="role-radio-new"></v-radio>
                              </div>
                              <div class="role-card-icon">
                                <img :src="user.roleId === 2 ? images.userRedIcon : images.userIcon" alt="User" class="role-icon-svg" />
                              </div>
                              <div class="role-card-label">{{ $t("generalUsers") }}</div>
                              <v-tooltip activator="parent" location="top" max-width="300">
                                <div class="tooltip-content">
                                  Has access assigned models and projects within their permission scope.
                                </div>
                              </v-tooltip>
                            </div>

                            <!-- Operator Card -->
                            <div class="role-card-new" :class="{ selected: user.roleId === 6 }"
                              @click="user.roleId = 6">
                              <div class="role-card-checkbox">
                                <v-radio :value="6" class="role-radio-new"></v-radio>
                              </div>
                              <div class="role-card-icon">
                                <img :src="user.roleId === 6 ? images.operatorRedIcon : images.operatorIcon" alt="Operator" class="role-icon-svg" />
                              </div>
                              <div class="role-card-label">{{ $t("_Operator") }}</div>
                              <v-tooltip activator="parent" location="top" max-width="300">
                                <div class="tooltip-content">
                                  Handle daily chat operations, monitoring, and responding to user interactions.
                                </div>
                              </v-tooltip>
                            </div>
                          </div>
                        </v-radio-group>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- Model Selection for General Users -->
                <v-row class="form-row" v-show="user.roleId == 2 || user.roleId == 6">
                  <v-col cols="12">
                    <div class="input-wrapper">
                      <label class="input-label">
                        Available Models
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                          </template>
                          <div class="tooltip-content">Choose which AI models are accessible for this user.</div>
                        </v-tooltip>
                      </label>
                      <v-autocomplete id="model-autocomplete-add-usermanagement" v-model="user.model"
                        :items="listDDModel" item-title="name" item-value="modelDisplayID" variant="outlined"
                        density="compact" multiple clearable hide-details="auto"
                        placeholder="Select Models" class="modern-input role-autocomplete model-autocomplete"
                        :menu-props="{ closeOnContentClick: false }"
                        @update:modelValue="(value) => handleModelSelection('add', value)">
                        <template #prepend-item>
                          <v-list-item
                            class="model-option-item model-all-option"
                            :class="{ 'model-all-option--active': isAllModelsSelected(user.model), 'model-all-option--disabled': !listDDModel.length }"
                            density="compact"
                            @mousedown.prevent
                            @click.stop="toggleAllModels('add')"
                          >
                            <template #prepend>
                              <v-checkbox-btn
                                class="model-option-checkbox"
                                :model-value="isAllModelsSelected(user.model)"
                                color="#C30000"
                                :ripple="false"
                                :disabled="!listDDModel.length"
                                @click.stop="toggleAllModels('add')"
                              ></v-checkbox-btn>
                            </template>
                            <template #title>
                              <div class="model-all-title">
                                <span class="model-all-option__label">All Model</span>
                                <v-tooltip location="top">
                                  <template #activator="{ props }">
                                    <v-icon v-bind="props" size="18" class="model-info-icon">mdi-information-outline</v-icon>
                                  </template>
                                  <span>All available models will be included in this group.</span>
                                </v-tooltip>
                              </div>
                            </template>
                          </v-list-item>
                          <v-divider class="model-all-divider"></v-divider>
                        </template>

                        <template #item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'model-add-usermanagement-option-' + index"
                            class="model-option-item" :class="{ 'model-option-item--selected': isModelSelected('add', item.raw.modelDisplayID) }"
                            @click="props.onClick" @mousedown.prevent>
                            <template #prepend>
                              <v-checkbox-btn class="model-option-checkbox" :model-value="isModelSelected('add', item.raw.modelDisplayID)"
                                color="#C30000" :ripple="false" @click.stop="props.onClick"></v-checkbox-btn>
                            </template>
                            <template #title>
                              <span class="model-option-title">{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>

                        <template #selection="{ item, index }">
                          <!-- When all models selected, show single "All Model" label only for first item -->
                          <span v-if="shouldCollapseModelChips(user.model) && index === 0" class="model-all-selected-label">
                            <!-- <v-icon size="16" color="#C30000" class="mr-1">mdi-check-all</v-icon> -->
                            All Model
                            <v-tooltip location="top">
                              <template #activator="{ props }">
                                <v-icon v-bind="props" size="18" class="model-info-icon">mdi-information-outline</v-icon>
                              </template>
                              <span>All available models will be included in this group.</span>
                            </v-tooltip>
                          </span>
                          <!-- When NOT all models selected, show chips with limit -->
                          <template v-else-if="!shouldCollapseModelChips(user.model)">
                            <v-chip v-if="index < modelChipDisplayLimit" class="model-chip" size="small" closable
                              @click:close="onModelChipClose('add', item.value)">
                              <template #close>x</template>
                              {{ item.title }}
                            </v-chip>
                            <v-chip v-else-if="index === modelChipDisplayLimit && hasHiddenModelChips(user.model)" class="model-chip more-chip" size="small">
                              {{ getHiddenModelChipLabel(user.model) }}
                            </v-chip>
                          </template>
                          <!-- Hide all other chips when all models are selected (index > 0) -->
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                </v-row>

                <v-row v-show="user.roleId == 2 || user.roleId == 6">
                  <v-col cols="6">
                    <div class="input-wrapper">
                      <label class="input-label">
                        Document
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                          </template>
                          <div class="tooltip-content">Manage or link documents used for training, responses, or knowledge base.</div>
                        </v-tooltip>
                      </label>
                      <v-autocomplete id="document-autocomplete-add-usermanagement" :items="listDDDocument"
                        v-model="user.vectordbName" item-title="name" item-value="name" variant="outlined"
                        density="compact" multiple chips closable-chips clearable hide-details="auto"
                        placeholder="Select Documents" class="modern-input role-autocomplete">
                        <template v-slot:chip="{ props, item }">
                          <v-chip v-bind="props" class="custom-chip">
                            {{ item.title }}
                            <span class="chip-close-divider">|</span>
                            <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'document-add-usermanagement-option-' + index"
                            :value="item.raw.name">
                            <template v-slot:title>
                              <span>{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="input-wrapper">
                      <label class="input-label">
                        Database Integration
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                          </template>
                          <div class="tooltip-content">Connect your system database to enable data retrieval.</div>
                        </v-tooltip>
                      </label>
                      <!-- Database integration - ADD USER -->
                      <v-autocomplete id="data-integration-autocomplete-add-usermanagement" :items="listDDDataIntegration"
                        v-model="user.dataIntegrationID" item-title="dataName" item-value="id" variant="outlined"
                        density="compact" multiple chips closable-chips clearable hide-details="auto"
                        placeholder="Select Database Integration" class="modern-input role-autocomplete">
                        <template v-slot:chip="{ props, item }">
                          <v-chip v-bind="props" class="custom-chip">
                            {{ item.title }}
                            <span class="chip-close-divider">|</span>
                            <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'data-integration-add-usermanagement-option-' + index"
                            :value="item.raw.id">
                            <template v-slot:title>
                              <span>{{ item.raw.dataName }}</span>
                            </template>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                </v-row>

                <v-row v-show="user.roleId == 2 || user.roleId == 6">
                  <v-col cols="6">
                    <div class="input-wrapper">
                      <label class="input-label">
                        Product Group Name
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                          </template>
                          <div class="tooltip-content">Specify the group for related products.</div>
                        </v-tooltip>
                      </label>
                      <v-autocomplete id="product-autocomplete-add-usermanagement" :items="listDDProductGroup"
                        v-model="user.productGroupID" item-title="productGroupName" item-value="productGroupID"
                        variant="outlined" density="compact" multiple chips closable-chips clearable hide-details="auto"
                        placeholder="Select Product Group Name" class="modern-input role-autocomplete">
                        <template v-slot:chip="{ props, item }">
                          <v-chip v-bind="props" class="custom-chip">
                            {{ item.title }}
                            <span class="chip-close-divider">|</span>
                            <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'product-add-usermanagement-option-' + index"
                            :value="item.raw.name">
                            <template v-slot:title>
                              <span>{{ item.raw.productGroupName }}</span>
                            </template>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="input-wrapper">
                      <label class="input-label">
                        Intent Group Name
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                          </template>
                          <div class="tooltip-content">Define a group of intents used to organize chatbot responses.</div>
                        </v-tooltip>
                      </label>
                      <v-autocomplete id="intentgroup-autocomplete-add-usermanagement" :items="listDDIntentGroup"
                        v-model="user.intentGroupID" item-title="name" item-value="id" variant="outlined"
                        density="compact" multiple chips closable-chips clearable hide-details="auto"
                        placeholder="Select Intent Group Name" class="modern-input role-autocomplete">
                        <template v-slot:chip="{ props, item }">
                          <v-chip v-bind="props" class="custom-chip">
                            {{ item.title }}
                            <span class="chip-close-divider">|</span>
                            <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'intentgroup-add-usermanagement-option-' + index"
                            :value="item.raw.name">
                            <template v-slot:title>
                              <span>{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                </v-row>

                <!-- Flows and Account Status Row -->
                <v-row class="form-row" v-show="user.roleId == 2 || user.roleId == 6">
                  <v-col cols="6">
                    <div class="input-wrapper">
                      <label class="input-label">
                        Flows
                        <v-tooltip location="top start" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                          </template>
                          <div class="tooltip-content">Configure conversation flows to control chatbot logic and user paths.</div>
                        </v-tooltip>
                      </label>
                      <v-autocomplete id="flow-autocomplete-add-usermanagement" :items="listDDFlowGroup"
                        v-model="user.flowGroupID" item-title="name" item-value="flowGroupID" variant="outlined"
                        density="compact" multiple chips closable-chips clearable hide-details="auto"
                        placeholder="Select Intent Group Name" class="modern-input role-autocomplete">
                        <template v-slot:chip="{ props, item }">
                          <v-chip v-bind="props" class="custom-chip">
                            {{ item.title }}
                            <span class="chip-close-divider">|</span>
                            <span class="chip-close-x" @click.stop="props['onClick:close']">x</span>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'flow-add-usermanagement-option-' + index"
                            :value="item.raw.name">
                            <template v-slot:title>
                              <span>{{ item.raw.name }}</span>
                            </template>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="account-status-container">
                      <div class="account-status-left">
                        <div class="account-status-label-row">
                          <span class="account-status-label">Account Status</span>
                          <v-tooltip location="top start" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                            </template>
                            <div class="tooltip-content">Indicates whether the user account is locked or unlocked.</div>
                          </v-tooltip>
                        </div>
                        <div class="account-status-description">
                          {{ user.lockStatus ? 'Account is Locked: User cannot access the system.' : 'Account is Unlocked: User can access the system.' }}
                        </div>
                      </div>
                      <div class="account-status-right">
                        <v-switch id="lockstatus-switch-add-usermanagement" v-model="user.lockStatus"
                          hide-details inset density="compact" :class="[
                            'publication-toggle',
                            user.lockStatus
                              ? 'publication-toggle--active'
                              : 'publication-toggle--inactive'
                          ]"></v-switch>
                        <v-chip size="small" :color="user.lockStatus ? '#C30000' : '#2ABF56'" variant="tonal" class="account-status-chip">
                          {{ user.lockStatus ? $t("_Locked") : $t("_Unlocked") }}
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- Account Status Row for non-operator/user roles -->
                <v-row class="form-row" v-show="user.roleId != 2 && user.roleId != 6">
                  <v-col cols="6">
                    <div class="account-status-container">
                      <div class="account-status-left">
                        <div class="account-status-label-row">
                          <span class="account-status-label">Account Status</span>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon v-bind="props" size="16" class="info-icon">mdi-information-outline</v-icon>
                            </template>
                            <div class="tooltip-content">Indicates whether the user account is locked or unlocked.</div>
                          </v-tooltip>
                        </div>
                        <div class="account-status-description">
                          {{ user.lockStatus ? 'Account is Locked: User cannot access the system.' : 'Account is Unlocked: User can access the system.' }}
                        </div>
                      </div>
                      <div class="account-status-right">
                        <v-switch id="lockstatus-switch-add-usermanagement-admin" v-model="user.lockStatus"
                          hide-details inset density="compact" :class="[
                            'publication-toggle',
                            user.lockStatus
                              ? 'publication-toggle--active'
                              : 'publication-toggle--inactive'
                          ]"></v-switch>
                        <v-chip size="small" :color="user.lockStatus ? '#C30000' : '#2ABF56'" variant="tonal" class="account-status-chip">
                          {{ user.lockStatus ? $t("_Locked") : $t("_Unlocked") }}
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left"></div>
            <div class="actions-right">
              <v-btn variant="outlined" color="grey" @click="closeadd" class="dialog-action-btn cancel-btn">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn id="button-save-popupadd-usermanagement" variant="elevated" @click="AddUser"
                class="dialog-action-btn save-btn-add">
                <v-img :src="images.newSaveImg" alt="Edit User Dialog" class="image-icon-style"></v-img>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--dialog change password-->
    <v-dialog v-model="changPasswordDialog" max-width="700px" persistent z-index="1000" class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">Change Password</h2>
              <p class="dialog-subtitle">
                Create a new secure password for your account
              </p>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="change-password-content">
          <!-- Security Tips -->
          <div class="security-tips-style template-description">
            <div class="alert-content">
              <strong>Security Tips:</strong>
              <ul class="tips-list">
                <li>Use a unique password that you don't use elsewhere</li>
                <li>
                  Consider using a passphrase with mixed case, numbers, and
                  symbols
                </li>
                <li>
                  Avoid personal information like names, birthdays, or
                  common words
                </li>
                <li>Change your password regularly for better security</li>
              </ul>
            </div>
          </div>

          <!-- Password Section -->
          <div class="form-section border-section-wrapper">
            <div class="section-title">
              <img :src="images.passwordIcon" alt="Password" class="image-icon-style" />
              Password Setup
            </div>

            <v-row class="form-row">
              <v-col cols="12" md="6">
                <div class="input-wrapper">
                  <label class="input-label">New Password <span class="required-asterisk">*</span></label>
                  <v-text-field id="password-field-popupedit-usermanagement" ref="password" v-model="edit.password"
                    :rules="[rules.required]" :type="show3 ? 'text' : 'password'" variant="outlined" density="compact"
                    hide-details="auto" placeholder="Password" class="modern-input">
                    <template v-slot:append-inner>
                      <v-btn @click="show3 = !show3" icon variant="text" size="small" class="password-toggle">
                        <img :src="show3 ? images.unlockIcon : images.lockIcon" alt="toggle password" class="password-toggle-icon" />
                      </v-btn>
                    </template>
                  </v-text-field>

                  <!-- Password Requirements with Animation -->
                  <transition name="slide-fade" mode="out-in">
                    <div class="password-requirements" v-if="edit.password" key="requirements">
                      <div class="requirement-item" :class="{ valid: checkLengthPassword }">
                        <v-icon size="15" :color="checkLengthPassword ? '#2ABF56' : '#C30000'">
                          {{
                            checkLengthPassword ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span>{{ $t("checklengthcharacters") }}</span>
                      </div>
                      <div class="requirement-item" :class="{ valid: checkLowercaseLetter }">
                        <v-icon size="15" :color="checkLowercaseLetter ? '#2ABF56' : '#C30000'">
                          {{
                            checkLowercaseLetter ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span>{{ $t("checklowercaseletter") }}</span>
                      </div>
                      <div class="requirement-item" :class="{ valid: checkUppercaseLetter }">
                        <v-icon size="15" :color="checkUppercaseLetter ? '#2ABF56' : '#C30000'">
                          {{
                            checkUppercaseLetter ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span>{{ $t("checkuppercaseletter") }}</span>
                      </div>
                      <div class="requirement-item" :class="{ valid: checkNumber }">
                        <v-icon size="15" :color="checkNumber ? '#2ABF56' : '#C30000'">
                          {{ checkNumber ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>{{ $t("checknumber") }}</span>
                      </div>
                      <div class="requirement-item" :class="{ valid: checkSpecialCharacter }">
                        <v-icon size="15" :color="checkSpecialCharacter ? '#2ABF56' : '#C30000'">
                          {{
                            checkSpecialCharacter ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span>{{ $t("checkspecialcharacter") }}</span>
                      </div>
                    </div>
                  </transition>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="input-wrapper">
                  <label class="input-label">Confirm New Password <span class="required-asterisk">*</span></label>
                  <v-text-field id="confirmpassword-field-popupedit-usermanagement" ref="confirmpassword"
                    v-model="edit.confirmpassword" :rules="[rules.required]" :type="show4 ? 'text' : 'password'"
                    variant="outlined" density="compact" hide-details="auto" placeholder="Confirm Password"
                    class="modern-input">
                    <template v-slot:append-inner>
                      <v-btn @click="show4 = !show4" icon variant="text" size="small" class="password-toggle">
                       <img :src="show4 ? images.unlockIcon : images.lockIcon" alt="toggle password" class="password-toggle-icon" />
                      </v-btn>
                    </template>
                  </v-text-field>

                  <!-- Password Match Indicator with Animation -->
                  <transition name="slide-fade" mode="out-in">
                    <div class="password-match" v-if="edit.confirmpassword" key="match">
                      <div class="requirement-item" :class="{ valid: checkPasswordMatch }">
                        <v-icon size="15" :color="checkPasswordMatch ? '#2ABF56' : '#C30000'">
                          {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>{{ $t("checkPwdMatch") }}</span>
                      </div>
                    </div>
                  </transition>
                </div>
              </v-col>
            </v-row>

            <!-- Password Strength Indicator with Animation -->
            <transition name="expand-fade" mode="out-in">
              <v-row class="mt-0" v-if="edit.password" key="strength">
                <v-col cols="12" class="pt-1">
                  <div class="password-strength-wrapper">
                    <div class="strength-label">
                      <v-icon size="16" :color="passwordStrength.color" class="mr-1">
                        {{ passwordStrength.icon }}
                      </v-icon>
                      Password Strength:
                      <span :style="{ color: passwordStrength.color }" class="strength-text">
                        {{ passwordStrength.text }}
                      </span>
                    </div>
                    <v-progress-linear :model-value="passwordStrength.value" :color="passwordStrength.color"
                      height="6" rounded class="strength-bar">
                    </v-progress-linear>
                  </div>
                </v-col>
              </v-row>
            </transition>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="change-password-actions">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" color="grey" @click="closeChangePassword" class="dialog-action-btn cancel-btn">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn id="button-savechangepassword-popupedit-usermanagement" variant="elevated" @click="saveChangePassword"
            :disabled="!passwordIsValid" class="dialog-action-btn save-btn-change-password">
            <v-img :src="images.newSaveImg" alt="Update Password" class="image-icon-style"></v-img>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <!-- Template Download Dialog -->
    <v-dialog v-model="flagTemplate" max-width="900px" persistent class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-text-content">
              <h2 class="dialog-title">Download Template</h2>
              <span class="dialog-subtitle">
                Download template files for user import
              </span>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="flagTemplate = false" class="close-button" color="black">
              <v-icon size="32">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="template-content">

          <div class="security-tips-style template-description mt-1 mb-4">
            <div class="alert-content">
              <strong>How to use templates:</strong>
              <ul class="tips-list pl-1">
                <li>Select the appropriate template format for your needs</li>
                <li>Download the template file</li>
                <li>
                  Fill in your user data following the template structure
                </li>
                <li>Upload the completed file using the import section</li>
              </ul>
            </div>
          </div>

          <!-- File Format Section -->
          <div class="file-format-section">
            <div class="file-format-header">
              <img :src="images.textFileIcon" alt="File Format" class="file-format-icon" />
              <span class="file-format-title">File Format</span>
            </div>

            <div class="file-format-cards pl-1">
              <!-- CSV Card -->
              <div id="button-downloadtemplate-csv-portaluermanagement" class="file-format-card"
                @click="linkDownload('CSV')" role="button" tabindex="0" @keydown.enter="linkDownload('CSV')">
                <div class="file-icon-wrapper csv-icon-bg">
                  <img :src="images.csvIcon" alt="CSV" class="file-type-icon" />
                </div>
                <span class="file-type-label">CSV</span>
                <v-tooltip activator="parent" location="top">
                  Download General - CSV Template
                </v-tooltip>
              </div>

              <!-- Excel Card -->
              <div id="button-downloadtemplate-excel-portaluermanagement" class="file-format-card"
                @click="linkDownload('Excel')" role="button" tabindex="0" @keydown.enter="linkDownload('Excel')">
                <div class="file-icon-wrapper excel-icon-bg">
                  <img :src="images.excelFileIcon" alt="Excel" class="file-type-icon" />
                </div>
                <span class="file-type-label">Excel</span>
                <v-tooltip activator="parent" location="top">
                  Download General - Excel Template
                </v-tooltip>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Apply Filter Confirmation Dialog -->
    <v-dialog v-model="applyFilterDialogOpen" max-width="520px" persistent class="apply-filter-confirm-dialog">
      <v-card class="apply-filter-confirm-card" rounded="sm">
        <v-card-title class="apply-filter-confirm-title px-5 py-3">
          Apply Filter
        </v-card-title>

        <v-card-text class="apply-filter-confirm-text px-5 py-6">
          Are you sure you want to apply selected filter?
        </v-card-text>

        <v-card-actions class="apply-filter-confirm-actions px-5 pb-3">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" class="apply-filter-cancel-btn mr-3" @click="cancelApplyFilter">
            Cancel
          </v-btn>
          <v-btn class="apply-filter-apply-btn" @click="confirmApplyFilter">
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import store from "../store";
import ExcelJS from "exceljs";

// import checkPermissionFour from "@/api/function.js";
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import DragDropFile from "@/components/DragDropFile.vue";
import editImg from "@/assets/Icons/Edit.png";
import deleteImg from "@/assets/Icons/Delete.png";
import templateImg from "@/assets/Icons/user-import.svg";
import downloadImg from "@/assets/lucide_download.svg";
import textFileIcon from "@/assets/images/memory_format-text.png";
import excelFileIcon from "@/assets/images/excel.png";
import csvIcon from "@/assets/images/csv.png";
import basicInfoIcon from "@/assets/Icons/basic_info.svg";
import passwordIcon from "@/assets/Icons/Group.svg";
import lockIcon from "@/assets/images/tabler_lock-off.png";
import unlockIcon from "@/assets/images/lock-on.png";
import shieldIcon from "@/assets/Icons/shield-acc.svg";
import superAdminIcon from "@/assets/Icons/super-admin.svg";
import adminIcon from "@/assets/Icons/admin.svg";
import userIcon from "@/assets/Icons/user.svg";
import operatorIcon from "@/assets/Icons/operator.svg";
import superAdminRedIcon from "@/assets/Icons/super-admin-red.svg";
import adminRedIcon from "@/assets/Icons/admin-red.svg";
import userRedIcon from "@/assets/Icons/user-red.svg";
import operatorRedIcon from "@/assets/Icons/operator-red.svg";
import newSaveImg from "@/assets/Icons/white-save-floppy.svg";
import deleteIcon from "@/assets/images/trash-solid.svg";

export default {
  name: "UserManagement",
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  components: { DragDropFile },
  mixins: [LogTrace],
  directives: {
    mask,
  },
  data: () => ({
    mask: "##########",
    show1: false,
    show2: false,
    show3: false,
    show4: false,
    formHasErrors: false,
    permission: {
      add: true,
      edit: true,
      delete: true,
    },
    mailcheck: false,
    phonecheck: false,
    filters: {
      username: [],
      email: [],
      employeeName: [],
      userType: [],
    },
    DDRole: [
      {
        name: "Admin",
        value: 1,
      },
      {
        name: "ผู้ใช้งานทั่วไป",
        value: 2,
      },
    ],
    numberRules: [(v) => !!v || "Input is required!"],
    rules: {
      required: (value) => value === null || !!value || "Required.",
      min: (v) => v.length >= 10 || "Min 10 numbers",
    },
    Email: null,
    gg: null,
    UserType: null,
    dialog: false,
    edit: {
      id: null,
      username: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      password: null,
      confirmpassword: null,
      roleId: null,
      userType: null,
      model: [],
      lockStatus: false,
      vectordbName: [],
      dataIntegrationID: [],
      productGroupID: [],
      intentGroupID: [],
      flowGroupID: []
    },
    user: {
      id: null,
      username: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      password: null,
      confirmpassword: null,
      roleId: 2,
      userType: null,
      model: [],
      lockStatus: false,
      vectordbName: [],
      dataIntegrationID: [],
      productGroupID: [],
      intentGroupID: [],
      flowGroupID: []
    },
    listDDModel: [],
    listDDIntentGroup: [],
    listDDFlowGroup: [],
    listDDProductGroup: [],

    oldPassword: "",
    Editdialog: false,
    Adddialog: false,
    isSearch: false,
    username: "",
    email: "",
    totalTable: 0,
    itemsPerPage: 10,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    today: null,
    userListDDL: [],
    userList: [],
    headers: [],
    secretKey: "01234567890123456789012345678901",
    roleId: Cookies.get("roleId"),
    isFirst: true,
    searchTotalTable: 0,
    sortBy: [],
    sortDesc: [],
    accept:
      "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    fileImportUser: null,
    flagTemplate: false,
    dataTemplate: [
      {
        CSV: "CSV",
        Excel: "Excel",
      },
    ],
    checkLengthPassword: true,
    checkLowercaseLetter: true,
    checkUppercaseLetter: true,
    checkNumber: true,
    checkSpecialCharacter: true,
    checkPasswordMatch: true,
    statusFormatPassword: false,
    statusPassword: false,
    flagChangePassword: false,
    changPasswordDialog: false,
    // Role Filter State
    roleFilterMenuOpen: false,
    selectedRoleFilter: null,
    tempSelectedRole: null,
    applyFilterDialogOpen: false,
    roleFilterOptions: [
      { label: "All Roles", value: null },
      { label: "Super Admin", value: 0 },
      { label: "Admin", value: 1 },
      { label: "User", value: 2 },
      { label: "Operator", value: 6 },
    ],
    modelChipDisplayLimit: 10,
    
    images: {
      edit: editImg,
      delete: deleteImg,
      templateImg: templateImg,
      downloadImg: downloadImg,
      csvIcon: csvIcon,
      excelFileIcon: excelFileIcon,
      textFileIcon: textFileIcon,
      basicInfoIcon: basicInfoIcon,
      passwordIcon: passwordIcon,
      lockIcon: lockIcon,
      unlockIcon: unlockIcon,
      shieldIcon: shieldIcon,
      superAdminIcon: superAdminIcon,
      adminIcon: adminIcon,
      userIcon: userIcon,
      operatorIcon: operatorIcon,
      superAdminRedIcon: superAdminRedIcon,
      adminRedIcon: adminRedIcon,
      userRedIcon: userRedIcon,
      operatorRedIcon: operatorRedIcon,
      newSaveImg: newSaveImg,
      deleteIcon: deleteIcon,
    },
    
  }),
  watch: {

    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    "user.password"() {
      let self = this;
      if (
        self.user.password != null &&
        self.user.password != undefined &&
        self.user.password != ""
      ) {
        self.checkLengthPassword = self.user.password.length >= 8;
        self.checkLowercaseLetter = /[a-z]/.test(self.user.password);
        self.checkUppercaseLetter = /[A-Z]/.test(self.user.password);
        self.checkNumber = /\d/.test(self.user.password);
        // self.checkSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(self.user.password);
        self.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(self.user.password);
        if (
          self.checkLengthPassword == true &&
          self.checkLowercaseLetter == true &&
          self.checkUppercaseLetter == true &&
          self.checkNumber == true &&
          self.checkSpecialCharacter == true
        ) {
          self.statusFormatPassword = true;
        } else {
          self.statusFormatPassword = false;
        }

        if (self.user.password == self.user.confirmpassword) {
          self.checkPasswordMatch = true;
        }
        if (
          self.user.confirmpassword != null &&
          self.user.confirmpassword.length > 0
        ) {
          self.checkPasswordMatch = false;
        }
      }
    },
    "user.confirmpassword"() {
      let self = this;
      self.checkPasswordMatch = self.user.password == self.user.confirmpassword;
      if (
        self.user.password == self.user.confirmpassword &&
        self.checkLengthPassword == true &&
        self.checkLowercaseLetter == true &&
        self.checkUppercaseLetter == true &&
        self.checkNumber == true &&
        self.checkSpecialCharacter == true
      ) {
        self.statusPassword = true;
      } else {
        self.statusPassword = false;
      }
    },
    "edit.password"() {
      let self = this;
      if (
        self.edit.password != null &&
        self.edit.password != undefined &&
        self.edit.password != ""
      ) {
        self.checkLengthPassword = self.edit.password.length >= 8;
        self.checkLowercaseLetter = /[a-z]/.test(self.edit.password);
        self.checkUppercaseLetter = /[A-Z]/.test(self.edit.password);
        self.checkNumber = /\d/.test(self.edit.password);
        // self.checkSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(self.edit.password);
        self.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(self.edit.password);
        if (
          self.checkLengthPassword == true &&
          self.checkLowercaseLetter == true &&
          self.checkUppercaseLetter == true &&
          self.checkNumber == true &&
          self.checkSpecialCharacter == true
        ) {
          self.statusFormatPassword = true;
        } else {
          self.statusFormatPassword = false;
        }
        if (self.edit.password == self.edit.confirmpassword) {
          self.checkPasswordMatch = true;
        } else if (
          self.edit.confirmpassword != null &&
          self.edit.confirmpassword.length > 0
        ) {
          self.checkPasswordMatch = false;
        }
      }
    },
    "edit.confirmpassword"() {
      let self = this;
      self.checkPasswordMatch = self.edit.password == self.edit.confirmpassword;
      if (
        self.edit.password == self.edit.confirmpassword &&
        self.checkLengthPassword == true &&
        self.checkLowercaseLetter == true &&
        self.checkUppercaseLetter == true &&
        self.checkNumber == true &&
        self.checkSpecialCharacter == true
      ) {
        self.statusPassword = true;
      } else {
        self.statusPassword = false;
      }
    },
  },
  mounted() {
    // this.permission = this.checkPermissionFour(1, 2, 3, 4);
    this.headers = [
      {
        title: "No.",
        key: "number",
        align: "center",
        sortable: false,
        width: "70px",
      },
      {
        title: "Username",
        key: "username",
        align: "start",
        sortable: true,
      },
      {
        title: "Email",
        key: "email",
        align: "start",
        sortable: true,
      },
      {
        title: "Phone Number",
        key: "mobile",
        align: "start",
        sortable: true,
      },
      {
        title: "Name",
        key: "fullName",
        align: "start",
        sortable: true,
      },
      {
        title: "Role",
        key: "roleId",
        align: "start",
        sortable: true,
      },
      {
        title: "Manage",
        key: "actions",
        align: "center",
        sortable: false,
        width: "120px",
      },
    ];
    this.GetDate();
    this.GetModel();
    this.GetDDIntentGroupName();
    this.GetDDProductGroupList();
    this.GetDDdataIntegration();
    this.GetDDVectorDBNameManagement();
    this.GetDDFlowGroup();
  },
  computed: {
    // filterListDDModel() {
    //   const data = this.listDDModel.filter((item, index, array) => {
    //     return array.findIndex(obj => obj.modelDisplayID === item.modelDisplayID) === index;
    //   });
    //   return data
    // },
    filteredUsers() {
      // Apply role filter if selected
      let users = this.userList.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });

      // Apply role filter
      if (this.selectedRoleFilter !== null) {
        users = users.filter(user => user.roleId === this.selectedRoleFilter);
      }

      return users;
    },
    filteredRoleCount() {
      // Count users based on selected role filter
      if (this.selectedRoleFilter === null) {
        return this.searchTotalTable;
      }
      return this.userList.filter(user => user.roleId === this.selectedRoleFilter).length;
    },
    form() {
      return {
        username: this.user.username,
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        email: this.user.email,
        phone: this.user.phone,
        password: this.user.password,
        confirmpassword: this.user.confirmpassword,
      };
    },
    headersTemplate() {
      return [
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
      ];
    },
    enhancedHeadersTemplate() {
      return [
        {
          title: "CSV",
          key: "csv",
          align: "center",
          width: "50%",
          sortable: false,
        },
        {
          title: "Excel",
          key: "excel",
          align: "center",
          width: "50%",
          sortable: false,
        },
      ];
    },
    passwordStrength() {
      if (!this.edit.password)
        return {
          value: 0,
          color: "grey",
          text: "No password",
          icon: "mdi-minus",
        };

      let score = 0;
      let feedback = [];

      // Length check
      if (this.edit.password.length >= 8) score += 20;
      else feedback.push("Use at least 8 characters");

      // Character variety checks
      if (/[a-z]/.test(this.edit.password)) score += 15;
      else feedback.push("Add lowercase letters");

      if (/[A-Z]/.test(this.edit.password)) score += 15;
      else feedback.push("Add uppercase letters");

      if (/\d/.test(this.edit.password)) score += 15;
      else feedback.push("Add numbers");

      if (/[^a-zA-Z0-9ก-๙]/.test(this.edit.password)) score += 15;
      else feedback.push("Add special characters");

      // Additional complexity
      if (this.edit.password.length >= 12) score += 10;
      if (this.edit.password.length >= 16) score += 10;

      if (score <= 30) {
        return {
          value: score,
          color: "#C30000",
          text: "Weak",
          icon: "mdi-shield-alert",
        };
      } else if (score <= 60) {
        return {
          value: score,
          color: "warning",
          text: "Fair",
          icon: "mdi-shield-half-full",
        };
      } else if (score <= 80) {
        return {
          value: score,
          color: "info",
          text: "Good",
          icon: "mdi-shield-check",
        };
      } else {
        return {
          value: score,
          color: "#2ABF56",
          text: "Strong",
          icon: "mdi-shield-check-outline",
        };
      }
    },
    passwordIsValid() {
      return (
        this.checkLengthPassword &&
        this.checkLowercaseLetter &&
        this.checkUppercaseLetter &&
        this.checkNumber &&
        this.checkSpecialCharacter &&
        this.checkPasswordMatch &&
        this.edit.password &&
        this.edit.confirmpassword
      );
    },
    isEditRoleLocked() {
      return (
        this.isOwnerUserType(this.edit.userType) ||
        (this.edit.roleId == 0 && this.roleId != "0")
      );
    },
  },

  methods: {
    isOwnerUserType(userType) {
      return typeof userType === "string" && userType.trim() === "Owner";
    },

    setEditRole(roleId) {
      if (this.isEditRoleLocked) {
        return;
      }

      this.edit.roleId = roleId;
    },

    // Get role name from roleId
    getRoleName(roleId) {
      const roles = {
        0: 'Super Admin',
        1: 'Admin',
        2: 'User',
        6: 'Operator'
      };
      return roles[roleId] || 'User';
    },

    // Get role filter label for display
    getRoleFilterLabel(roleId) {
      if (roleId === null) {
        return 'All Roles';
      }
      const matchedRole = this.roleFilterOptions.find((option) => option.value === roleId);
      return matchedRole ? matchedRole.label : 'All Roles';
    },
    handleModelSelection(context, value) {
      const target = context === 'edit' ? this.edit : this.user;
      const safeValues = Array.isArray(value) ? Array.from(new Set(value)) : [];
      const allIds = this.listDDModel.map((model) => model.modelDisplayID);

      if (safeValues.length >= allIds.length && allIds.length > 0) {
        target.model = allIds.slice();
      } else {
        target.model = safeValues;
      }
    },
    toggleAllModels(context) {
      const allIds = this.listDDModel.map((model) => model.modelDisplayID);
      if (allIds.length === 0) {
        return;
      }

      const target = context === 'edit' ? this.edit : this.user;
      if (this.isAllModelsSelected(target.model)) {
        target.model = [];
      } else {
        target.model = allIds.slice();
      }
    },
    isAllModelsSelected(selectedModels) {
      const allIds = this.listDDModel.map((model) => model.modelDisplayID);
      if (!Array.isArray(selectedModels) || selectedModels.length === 0) {
        return false;
      }

      if (selectedModels.length !== allIds.length) {
        return false;
      }

      return allIds.every((id) => selectedModels.includes(id));
    },
    isModelSelected(context, modelId) {
      const target = context === 'edit' ? this.edit : this.user;
      return Array.isArray(target.model) && target.model.includes(modelId);
    },
    onModelChipClose(context, modelId) {
      const target = context === 'edit' ? this.edit : this.user;
      if (!Array.isArray(target.model)) {
        target.model = [];
        return;
      }

      if (this.isAllModelsSelected(target.model)) {
        target.model = [];
      } else {
        target.model = target.model.filter((id) => id !== modelId);
      }
    },
    shouldCollapseModelChips(selectedModels) {
      return this.isAllModelsSelected(selectedModels);
    },
    hasHiddenModelChips(selectedModels) {
      if (!Array.isArray(selectedModels)) {
        return false;
      }
      return selectedModels.length > this.modelChipDisplayLimit && !this.shouldCollapseModelChips(selectedModels);
    },
    getHiddenModelChipLabel(selectedModels) {
      if (!this.hasHiddenModelChips(selectedModels)) {
        return '';
      }
      const remaining = selectedModels.length - this.modelChipDisplayLimit;
      return remaining > 0 ? `+${remaining} more` : '';
    },
    getCollapsedChipLabel(selectedModels) {
      return this.shouldCollapseModelChips(selectedModels) ? 'All Model' : '';
    },

    // Show apply filter confirmation dialog
    showApplyFilterConfirmation() {
      this.roleFilterMenuOpen = false;
      this.applyFilterDialogOpen = true;
    },

    // Cancel apply filter
    cancelApplyFilter() {
      this.applyFilterDialogOpen = false;
    },

    // Confirm and apply the filter
    confirmApplyFilter() {
      this.selectedRoleFilter = this.tempSelectedRole;
      this.applyFilterDialogOpen = false;
      this.roleFilterMenuOpen = false;
      this.Get();
    },

    showImportWarning(title, messageHtml) {
      const rawOkLabel = this.$t ? this.$t("ok") : "OK";
      const confirmLabel = rawOkLabel && rawOkLabel.toString().trim().length > 0
        ? rawOkLabel
        : "OK";

      return this.$swal.fire({
        title,
        html: messageHtml,
        icon: "warning",
        showCloseButton: true,
        focusConfirm: true,
        buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: confirmLabel,
        customClass: {
          popup: "swal-warning-popup",
          title: "swal-warning-title",
          htmlContainer: "swal-warning-body",
          actions: "swal-warning-actions",
          confirmButton: "swal-warning-confirm",
          closeButton: "swal-warning-close",
        },
      });
    },

    showIncompleteInfoAlert(context) {
      const cancelText = `<span class="swal-warning-cancel-content"><i class="mdi mdi-exit-to-app"></i>Leave Anyway</span>`;
      const confirmText = `<span class="swal-warning-continue-content">Continue<span class="swal-warning-continue-arrow">&rarr;</span></span>`;

      return this.$swal
        .fire({
          title: "Incomplete Information",
          html: "Please complete all required fields before saving. Some information is missing.",
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          buttonsStyling: false,
          focusCancel: true,
          reverseButtons: true,
          cancelButtonText: cancelText,
          confirmButtonText: confirmText,
          customClass: {
            popup: "swal-warning-popup",
            title: "swal-warning-title",
            htmlContainer: "swal-warning-body",
            actions: "swal-warning-actions",
            cancelButton: "swal-warning-cancel",
            confirmButton: "swal-warning-confirm swal-warning-continue",
            closeButton: "swal-warning-close",
          },
        })
        .then((result) => {
          const dismissReason = (this.$swal && this.$swal.DismissReason) || {};
          if (result && result.dismiss === dismissReason.cancel) {
            if (context === "add") {
              this.Adddialog = false;
              this.formHasErrors = false;
            } else if (context === "edit") {
              this.Editdialog = false;
              this.formHasErrors = false;
            }
          }
          return result;
        });
    },

    fieldHasValue(value) {
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === "string") {
        return value.trim().length > 0;
      }
      return value !== null && value !== undefined;
    },

    isAddFieldInvalid(field) {
      if (!this.formHasErrors) {
        return false;
      }
      return !this.fieldHasValue(this.user[field]);
    },

    isEditFieldInvalid(field) {
      if (!this.formHasErrors) {
        return false;
      }
      return !this.fieldHasValue(this.edit[field]);
    },

    async GetDDVectorDBNameManagement() {
      this.$call.GetDDVectorDBNameManagement(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDDocument = dataResponse.data;
          } else {
            this.listDDDocument = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },

    async GetDDdataIntegration() {
      await this.$call.GetDDdataintegration(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDDataIntegration = dataResponse.data;
          } else {
            this.listDDDataIntegration = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },

    async GetDDProductGroupList() {
      await this.$call.GetDDProductGroupList(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDProductGroup = dataResponse.data
          } else {
            this.listDDProductGroup = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },
    async GetDDIntentGroupName() {
      await this.$call.DDIntentGroup(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDIntentGroup = dataResponse.data;
          } else {
            this.listDDIntentGroup = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },
    async GetDDFlowGroup() {
      await this.$call.GetFlowDropdown(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDFlowGroup = dataResponse.data;
          } else {
            this.listDDFlowGroup = [];
          }
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      )
    },
    triggerFileUpload() {
      // เลือกวิธีใดวิธีหนึ่ง:

      // วิธีที่ 1: ถ้า DragDropFile มี method openFileDialog ที่ expose ออกมา
      if (
        this.$refs.fileUploader &&
        typeof this.$refs.fileUploader.openFileDialog === "function"
      ) {
        this.$refs.fileUploader.openFileDialog();
      }
      // วิธีที่ 2: เข้าถึง input file ภายใน DragDropFile โดยตรง (ถ้าเป็นไปได้)
      else if (this.$refs.fileUploader && this.$refs.fileUploader.$el) {
        const fileInput =
          this.$refs.fileUploader.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    processUpload(e) {
      let self = this;
      if (e.length > 0) {
        self.fileImportUser = e[0];
        const fileType = self.fileImportUser.name
          .split(".")
          .pop()
          .toLowerCase();

        if (fileType === "xlsx" || fileType === "xls") {
          const reader = new FileReader();
          reader.onload = async (event) => {
            const buffer = event.target.result;
            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(buffer);

            const worksheet = workbook.getWorksheet(1);
            if (!worksheet) {
              self.showImportWarning("Error", "No worksheet found in the Excel file");
              return;
            }

            // Convert ExcelJS format to JSON object with headers
            const jsonData = [];
            const headers = [];

            // Extract headers from first row
            worksheet.getRow(1).eachCell((cell) => {
              headers.push(cell.value);
            });

            // Process data rows
            worksheet.eachRow((row, rowNumber) => {
              if (rowNumber === 1) return; // Skip header row

              const rowData = {};
              row.eachCell((cell, colNumber) => {
                rowData[headers[colNumber - 1]] = cell.value;
              });

              jsonData.push(rowData);
            });

            self.validateData(jsonData);
          };
          reader.readAsArrayBuffer(self.fileImportUser);
        } else if (fileType === "csv") {
          const reader = new FileReader();
          reader.onload = (event) => {
            const text = event.target.result;
            const rows = text.split("\n").map((row) => row.split(","));
            const headers = rows[0].map((header) => header.trim());
            const jsonData = rows
              .slice(1)
              .map((row) => {
                const obj = {};
                row.forEach((cell, index) => {
                  obj[headers[index]] = cell.trim();
                });
                return obj;
              })
              .filter((row) => Object.keys(row).length > 0);

            self.validateData(jsonData);
          };
          reader.readAsText(self.fileImportUser);
        } else {
          self.showImportWarning("Invalid File Type", "Please upload an Excel (.xlsx) or CSV (.csv) file.");
        }
      }
    },
    
    validateData(data) {
      let self = this;
      const requiredColumns = ["User Name", "Email"];
      const missingColumns = requiredColumns.filter(
        (col) => !Object.keys(data[0] || {}).includes(col)
      );
      if (missingColumns.length > 0) {
        self.showImportWarning(
          "Missing Columns",
          `The following required columns are missing: ${missingColumns.join(", ")}`
        );
        return;
      }

      const usernames = data
        .map((row) => row["User Name"]?.trim())
        .filter(Boolean);
      const emails = data
        .map(row => typeof row.Email === "string"
          ? row.Email.trim()
          : row.Email?.text?.trim()
        )
        .filter(Boolean);


      const duplicateUsernames = usernames.filter(
        (value, index, self) => self.indexOf(value) !== index
      );
      const duplicateEmails = emails.filter(
        (value, index, self) => self.indexOf(value) !== index
      );

      if (duplicateUsernames.length > 0 || duplicateEmails.length > 0) {
        let errorMessage = "";
        if (duplicateUsernames.length > 0) {
          errorMessage += `Duplicate usernames<br/> - ${[
            ...new Set(duplicateUsernames),
          ].join(", ")}<br/>`;
        }
        if (duplicateEmails.length > 0) {
          errorMessage += `Duplicate emails<br/> - ${[
            ...new Set(duplicateEmails),
          ].join(", ")}<br/>`;
        }
        self.showImportWarning(self.$t("warning"), errorMessage);
      } else {
        self.ConfirmProcess();
      }
    },

    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          icon: "warning",
          title: this.$t("importUserTitle"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.ImportUser();
          }
        });
    },

    async ImportUser() {
      let self = this;
      self.dialog = true;
      const formDataDoc = new FormData();
      formDataDoc.append("entity", self.fileImportUser);

      var requestUser = {
        entity: formDataDoc,
        isUserChat: false,
      };

      await self.$call.ImportUser(
        requestUser,
        null,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (
              dataResponse.data.mesDupUser.length > 0 ||
              dataResponse.data.mesDupEmail.length > 0 ||
              dataResponse.data.mesEmailNotFormat.length > 0 ||
              dataResponse.data.mesFillAll.length > 0 ||
              dataResponse.data.mesModelNotFormat.length > 0 ||
              dataResponse.data.mesWarningSuperAdmin.length > 0
            ) {
              let DupUser = dataResponse.data.mesDupUser;
              let DupEmail = dataResponse.data.mesDupEmail;
              let EmailNotFormat = dataResponse.data.mesEmailNotFormat;
              let FillAll = dataResponse.data.mesFillAll;
              let mesModelNotFormat = dataResponse.data.mesModelNotFormat;
              let WarningSuperAdmin = dataResponse.data.mesWarningSuperAdmin;
              var htmlString = "";
              // let maxRowWarning = 20;
              // let countRowWarning = 0;
              const countDupUser = DupUser.length;
              const countDupEmail = DupEmail.length;
              const countEmailNotFormat = EmailNotFormat.length;
              const countFillAll = FillAll.length;
              const countModelNotFormat = mesModelNotFormat.length;
              const countWarningSuperAdmin = WarningSuperAdmin.length;

              for (let i = 0; i < countDupUser; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "Duplicate username - ";
                }
                htmlString += DupUser[i];
                htmlString += i == countDupUser - 1 ? "</br>" : ", ";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countDupEmail; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "Duplicate email - ";
                }
                htmlString +=  DupEmail[i];
                htmlString += i == countDupEmail - 1 ? "</br>" : ", ";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countEmailNotFormat; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "Email is not formatted correctly - ";
                }
                htmlString += EmailNotFormat[i];
                htmlString += i == countEmailNotFormat - 1 ? "</br>" : ", ";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countFillAll; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "Please fill the required fields - ";
                }
                htmlString += FillAll[i];
                htmlString += i == countFillAll - 1 ? "</br>" : ", ";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countModelNotFormat; i++) {
                // countRowWarning++;
                // if(countRowWarning <= maxRowWarning)
                // {
                if (i == 0) {
                  htmlString += "Model is not formatted correctly - ";
                }
                htmlString +=  mesModelNotFormat[i];
                htmlString += i == countModelNotFormat - 1 ? "</br>" : ", ";
                // }
                // else
                // {
                //   break;
                // }
              }
              for (let i = 0; i < countWarningSuperAdmin; i++) {
                if (i == 0) {
                  htmlString +=
                    "This username is not allowed to be a SuperAdmin role.</br>";
                }
                htmlString += " -" + WarningSuperAdmin[i] + "</br>";
              }

              self.showImportWarning("Warning!", htmlString);
            } else {
              self.$swal.fire({
                title: "✔ User Imported Successfully !",
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              // self.$swal.fire({
              //   icon: "success",
              //   title: dataResponse.message,
              //   showConfirmButton: false,
              //   timer: 1500,
              // });
              self.Get();
            }
          } else {
            self.showImportWarning("Warning!", dataResponse.message);
          }
          self.options.page = 1;
          self.Get();
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    linkDownload(modelType) {
      let self = this;
      let req = {
        modelType: modelType,
        filename: "User",
      };
      self.$call.DownloadTemplateUser(
        req,
        async (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            let fileNameshow = `Template_User_${modelType}${await self.findTypeName(
              modelType
            )}`;
            fileLink.setAttribute("download", fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.flagTemplate = false;
        },
        (errorResource) => {
          self.flagTemplate = false;
          console.error(errorResource);
        }
      );
    },

    async findTypeName(modelType) {
      let type = "";
      switch (modelType) {
        case "CSV":
          type = ".csv";
          break;
        case "Excel":
          type = ".xlsx";
          break;
        case "ExcelMultiColumn":
          type = ".xlsx";
          break;
        case "PDF":
          type = ".pdf";
          break;
        case "Word":
          type = ".docx";
          break;
        case "Text":
          type = ".txt";
          break;
        case "PowerPoint":
          type = ".pptx";
          break;
      }
      return type;
    },

    PhoneNumberValidation(phno) {
      let phoneno = /^\d{10}$/;
      return phoneno.test(phno) || "Invalid Phone format";
    },

    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email) || "invalid email";
    },
    clearFilters() {
      this.username = "";
      this.email = "";
      this.selectedRoleFilter = null;
      this.tempSelectedRole = null;
      this.roleFilterMenuOpen = false;
      this.applyFilterDialogOpen = false;
      this.Search();
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.GetDefault();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },

    GetModel() {
      let self = this;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {

            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    Get() {
      try {
        let self = this;
        self.loadingTable = true;

        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          username: self.username,
          eMail: self.email,
          sortDesc: sortOrder,
          sortBy: sortField,
          roleId: self.selectedRoleFilter !== null ? [self.selectedRoleFilter] : [],
        };
        self.$call.GetTableUserManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.userListDDL = dataResponse.data.data;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.loadingTable = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.loadingTable = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    GetDefault() {
      try {
        let self = this;
        self.dialog = true;
        const { page, itemsPerPage } = this.options;
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          username: self.username,
          eMail: self.email,
          sortDesc: null,
          sortBy: null,
          roleId: self.selectedRoleFilter !== null ? [self.selectedRoleFilter] : [],
        };
        self.$call.GetTableUserManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.userListDDL = dataResponse.data.data;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    EditUser(temp) {
      let self = this;
      // self.oldPassword = self.decryptShiftData(temp.password, 7);
      self.Editdialog = true;
      self.formHasErrors = false;
      self.edit.id = temp.userId;
      self.edit.username = temp.username;
      self.edit.firstname = temp.firstName;
      self.edit.lastname = temp.lastName;
      // self.edit.password = temp.password;
      //self.edit.password = self.decryptShiftData(temp.password, 7);
      // self.edit.employeename = temp.employeeName;
      self.edit.roleId =
        temp.roleId == null || temp.roleId == undefined ? 2 : temp.roleId;
      self.edit.userType = temp.userType;
      self.edit.email = temp.email;
      self.edit.phone = temp.mobile;
      self.edit.model = temp.model;
      self.edit.lockStatus = temp.isLock;
      (self.edit.password = ""), (self.edit.confirmpassword = "");
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.flagChangePassword = false;

      self.edit.vectordbName = temp.vectordbName;
      self.edit.dataIntegrationID = temp.dataIntegrationID;
      self.edit.productGroupID = temp.productGroupID;
      self.edit.intentGroupID = temp.intentGroupID;
      self.edit.flowGroupID = temp.flowGroupID;
    },
    UpdateUser() {
      try {
        let self = this;
        self.dialog = true;
        let emailvali = self.validateEmail(self.edit.email);
        // let phonevali = self.PhoneNumberValidation(self.edit.phone);
        if (
          self.edit.username != "" &&
          self.edit.lastname != "" &&
          self.edit.firstname != "" &&
          self.edit.email != "" &&
          // self.edit.phone != '' &&
          // ((self.edit.password != '' && self.flagChangePassword == false) ||
          // (self.edit.password != '' && self.edit.confirmpassword != '' && self.flagChangePassword == true && self.statusPassword == true && self.statusFormatPassword == true)) &&
          self.edit.roleId != null &&
          // self.edit.userType != "" &&
          emailvali /*&&
          phonevali*/
        ) {
          let tempUser = {
            userId: self.edit.id,
            username: self.edit.username,
            // password: self.flagChangePassword ? self.edit.password : "",
            idcard: 0,
            prefixId: 0,
            firstName: self.edit.firstname,
            lastName: self.edit.lastname,
            // roleId: 1,
            roleId: self.edit.roleId,
            // userType: self.edit.userType,
            mobile: self.edit.phone,
            eMail: self.edit.email,
            model: self.edit.roleId == 1 ? null : self.edit.model,
            lockStatus: self.edit.lockStatus,
            vectordbName: self.edit.vectordbName,
            databaseIntegrationID: self.edit.dataIntegrationID,
            productGroupID: self.edit.productGroupID,
            intentGroupID: self.edit.intentGroupID,
            flowGroupID: self.edit.flowGroupID
          };
          self.$call.UpdateUser(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                if (Cookies.get("userId") == self.edit.id) {
                  Cookies.set(
                    "fullName",
                    `${self.edit.firstname} ${self.edit.lastname}`
                  );
                  store.state.fullName = `${self.edit.firstname} ${self.edit.lastname}`;
                  Cookies.set("username", self.edit.username);
                  if (self.oldPassword != self.edit.password) {
                    self.$call.ClearUserInfo();
                    self.$router.push("/login");
                  }
                }
                self.$swal.fire({
                  title: "✔ Successfully Saved !",
                  showConfirmButton: false,
                  timer: 1500,
                  customClass: {
                    popup: 'success-banner',
                    title: 'success-banner-title'
                  },
                });
                // self.$swal.fire({
                //   icon: "success",
                //   title: dataResponse.message,
                //   showConfirmButton: false,
                //   timer: 1500,
                // });
                self.formHasErrors = false;
                self.Editdialog = false;
                self.edit.name = null;
                self.edit.surname = null;
                self.edit.email = null;
                self.edit.department = null;
                self.edit.section = null;
                self.edit.status = null;
                self.edit.roleId = null;
                self.edit.userType = null;
                self.Get();
              } else if (dataResponse.status == 4) {
                self.$swal.fire({
                  icon: "warning",
                  title: this.$t("oneSuperAdmin"),
                  showConfirmButton: false,
                  timer: 2000,
                });
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (emailvali != true /*|| phonevali != true*/) {
            // alert("please fill correct format");
            self.$swal.fire({
              icon: "warning",
              title: this.$t("please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.username == "" ||
            self.edit.firstname == "" ||
            self.edit.lastname == "" ||
            self.edit.roleId == "" ||
            self.edit.userType == "" ||
            self.edit.confirmpassword == "" ||
            self.edit.password == null ||
            self.edit.confirmpassword == null
          ) {
            // self.$swal.fire({
            //   icon: "warning",
            //   title: this.$t("please fill all fields!!!"),
            //   showConfirmButton: false,
            //   timer: 2000,
            // });
            self.showIncompleteInfoAlert("edit");
          } else if (self.user.roleId == null) {
            // alert("Please fill correct format!");
            self.$swal.fire({
              icon: "warning",
              title: this.$t("please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.Editdialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    DeleteUser(user) {
      let self = this;
      let id = user.userId;
      try {
        if (user.roleId == 0 && self.roleId != "0") {
          self.$swal.fire({
            icon: "warning",
            title: this.$t("notAuthoritySuperAdmin"),
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            // text: this.$t("confirmDeletionUser"),
            html: "Do you want to confirm deletion of this user? This action cannot be undone.",
            icon: "warning",
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonText: this.$t("cancel"),
            confirmButtonText: `<span class="swal-delete-btn-content"><img src="${deleteIcon}" alt="" class="swal-delete-btn-icon" />${this.$t("delete")}</span>`,
            reverseButtons: false,
            focusCancel: true,
            buttonsStyling: false,
            customClass: {
              popup: "swal-delete-popup",
              title: "swal-delete-title",
              htmlContainer: "swal-delete-body",
              actions: "swal-delete-actions",
              confirmButton: "swal-delete-confirm",
              cancelButton: "swal-delete-cancel",
            },
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              
              self.$call.DeleteUser(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.totalTable = self.totalTable - 1;
                    self.Get();

                    self.$swal.fire({
                      title: "✔ Successfully Deleted !",
                      showConfirmButton: false,
                      timer: 1500,
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                    // self.$swal.fire({
                    //   icon: "success",
                    //   title: dataResponse.message,
                    //   showConfirmButton: false,
                    //   timer: 1500,
                    // });
                  } else if (dataResponse.status == 4) {
                    self.$swal.fire({
                      icon: "warning",
                      title: this.$t("oneSuperAdmin"),
                      showConfirmButton: false,
                      timer: 2000,
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteUser");
      }
    },
    closeedit() {
      let self = this;
      self.Editdialog = false;
      self.formHasErrors = false;
    },
    closeadd() {
      let self = this;

      Object.keys(self.form).forEach((f) => {
        if (self.$refs[f]) {
          self.$refs[f].reset();
        }
      });

      self.Adddialog = false;
      // Reset all autocomplete fields
      self.user.model = [];
      self.user.vectordbName = [];
      self.user.dataIntegrationID = [];
      self.user.productGroupID = [];
      self.user.intentGroupID = [];
      self.user.flowGroupID = [];
      self.user.lockStatus = false;
      self.user.roleId = 2;
      self.formHasErrors = false;
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.show1 = false;
      self.show2 = false;
    },
    AddUser() {
      try {
        let self = this;
        self.dialog = true;

        let emailvali = self.validateEmail(self.user.email);
        // let phonevali = self.PhoneNumberValidation(self.user.phone);
        if (
          self.user.username != null &&
          self.user.lastname != null &&
          self.user.firstname != null &&
          self.user.email != null &&
          // self.user.phone != null &&
          self.user.password != null &&
          self.user.confirmpassword != null &&
          self.user.roleId != null &&
          // self.user.userType != null &&
          self.statusPassword == true &&
          self.statusFormatPassword == true &&
          emailvali == true /*&&
            phonevali == true*/
        ) {
          let tempUser = {
            username: self.user.username,
            password: self.user.password,
            idCard: 0,
            prefixId: 0,
            firstName: self.user.firstname,
            lastName: self.user.lastname,
            // roleId: 1,
            roleId: self.user.roleId,
            // userType: self.user.userType,
            mobile: self.user.phone,
            eMail: self.user.email,
            model:
              self.user.roleId == 0 || self.user.roleId == 1
                ? null
                : self.user.model,
            lockStatus: self.user.lockStatus,

            vectordbName: self.user.roleId == 0 || self.user.roleId == 1
              ? null
              : self.user.vectordbName,
            DatabaseIntegrationID: self.user.roleId == 0 || self.user.roleId == 1
              ? null
              : self.user.dataIntegrationID,
            ProductGroupID: self.user.roleId == 0 || self.user.roleId == 1
              ? null
              : self.user.productGroupID,
            IntentGroupID: self.user.roleId == 0 || self.user.roleId == 1
              ? null
              : self.user.intentGroupID,
            FlowGroupID: self.user.roleId == 0 || self.user.roleId == 1
              ? null
              : self.user.flowGroupID
          };
          self.$call.CreateUser(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ New User Created Successfully.",
                  showConfirmButton: false,
                  timer: 1500,
                  customClass: {
                    popup: 'success-banner',
                    title: 'success-banner-title'
                  },
                });
                // self.$swal.fire({
                //   icon: "success",
                //   title: dataResponse.message,
                //   showConfirmButton: false,
                //   timer: 1500,
                // });
                self.Adddialog = false;
                self.user.firstname = null;
                self.user.lastname = null;
                self.user.username = null;
                self.user.email = null;
                self.user.phone = null;
                self.user.model = null;
                self.user.password = "";
                self.user.confirmpassword = "";
                self.checkLengthPassword = true;
                self.checkLowercaseLetter = true;
                self.checkUppercaseLetter = true;
                self.checkNumber = true;
                self.checkSpecialCharacter = true;
                self.checkPasswordMatch = true;
                self.show1 = false;
                self.show2 = false;
                self.dialog = false;
                self.formHasErrors = false;
                self.totalTable = self.totalTable + 1;
                self.Get();
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (
            self.user.username == null &&
            self.user.firstname == null &&
            self.user.lastname == null &&
            self.user.password == null &&
            self.user.confirmpassword == null &&
            self.user.roleId == null &&
            self.user.userType == null &&
            emailvali != true /*&&phonevali != true*/
          ) {
            // self.$swal.fire({
            //   icon: "warning",
            //   title: self.$t("warning"),
            //   text: self.$t("Please fill all the fields!!!"),
            //   showConfirmButton: false,
            //   timer: 2000,
            // });
            self.showIncompleteInfoAlert("add");
          } else if (
            self.user.username == null ||
            self.user.firstname == null ||
            self.user.lastname == null
          ) {
            // self.$swal.fire({
            //   icon: "warning",
            //   title: self.$t("warning"),
            //   text: self.$t("Please fill all the fields!!!"),
            //   showConfirmButton: false,
            //   timer: 2000,
            // });
            self.showIncompleteInfoAlert("add");
          } else if (emailvali != true /*|| phonevali != true*/) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password == null &&
            self.user.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password and Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password != null &&
            self.user.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password == null &&
            self.user.confirmpassword != null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password != self.user.confirmpassword &&
            self.checkPasswordMatch == false
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t(
                "Password and Confirm Password do not match.Please fill correctly."
              ),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            !self.checkLengthPassword ||
            !self.checkLowercaseLetter ||
            !self.checkUppercaseLetter ||
            !self.checkNumber ||
            !self.checkSpecialCharacter
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (self.user.roleId == null) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.Adddialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "AddUser");
      }
    },
    decryptData(encryptedText, key) {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key);
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedText;
    },
    decryptShiftData(encryptedText, shift) {
      let chars = encryptedText.split("");
      let decryptedChars = [];

      for (let i = 0; i < chars.length; i++) {
        let c = chars[i];

        if (/[a-zA-Z]/.test(c)) {
          let offset =
            c === c.toUpperCase() ? "A".charCodeAt(0) : "a".charCodeAt(0);
          c = String.fromCharCode(
            ((c.charCodeAt(0) - offset - shift + 26) % 26) + offset
          );
        } else if (/[0-9]/.test(c)) {
          c = String.fromCharCode(
            ((c.charCodeAt(0) - "0".charCodeAt(0) - shift + 10) % 10) +
            "0".charCodeAt(0)
          );
        }

        decryptedChars.push(c);
      }

      return decryptedChars.join("");
    },
    closeChangePassword() {
      let self = this;
      self.edit.password = "";
      self.edit.confirmpassword = "";
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.changPasswordDialog = false;
      self.show3 = false;
      self.show4 = false;
    },
    saveChangePassword() {
      try {
        let self = this;
        self.dialog = true;
        if (
          self.edit.password != "" &&
          self.edit.confirmpassword != "" &&
          self.edit.password != null &&
          self.edit.confirmpassword != null &&
          self.edit.password != undefined &&
          self.edit.confirmpassword != undefined &&
          self.edit.password == self.edit.confirmpassword &&
          self.checkPasswordMatch == true &&
          self.checkLengthPassword &&
          self.checkLowercaseLetter &&
          self.checkUppercaseLetter &&
          self.checkNumber &&
          self.checkSpecialCharacter
        ) {
          let temp = {
            userID: self.edit.id,
            password: self.edit.password,
          };
          self.$call.ChangePassword(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ Successfully Saved !",
                  showConfirmButton: false,
                  timer: 1500,
                  customClass: {
                    popup: 'success-banner',
                    title: 'success-banner-title'
                  },
                });
                // self.$swal.fire({
                //   icon: "success",
                //   title: dataResponse.message,
                //   showConfirmButton: false,
                //   timer: 1500,
                // });
                self.edit.password = "";
                self.edit.confirmpassword = "";
                self.checkLengthPassword = true;
                self.checkLowercaseLetter = true;
                self.checkUppercaseLetter = true;
                self.checkNumber = true;
                self.checkSpecialCharacter = true;
                self.checkPasswordMatch = true;
                self.changPasswordDialog = false;
                self.show3 = false;
                self.show4 = false;
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          // if ((self.edit.password == '' || self.edit.password == null || self.edit.password == undefined) &&
          //    (self.edit.confirmpassword != '' && self.edit.confirmpassword != null && self.edit.confirmpassword != undefined)) {
          //   self.$swal.fire({
          //     icon: 'warning',
          //     title: self.$t('warning'),
          //     text: self.$t('Please fill Password!'),
          //     showConfirmButton: false,
          //     timer: 2000,
          //   });
          // } else if ((self.edit.confirmpassword == '' || self.edit.confirmpassword == null || self.edit.confirmpassword == undefined) &&
          //   (self.edit.password != '' && self.edit.password != null && self.edit.password != undefined)) {
          //   self.$swal.fire({
          //     icon: 'warning',
          //     title: self.$t('warning'),
          //     text: self.$t('Please fill Confirm Password!'),
          //     showConfirmButton: false,
          //     timer: 2000,
          //   });
          // }
          if (self.edit.password != null && self.edit.confirmpassword == null) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password == null &&
            self.edit.confirmpassword != null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password == null &&
            self.user.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password and Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            !self.checkLengthPassword ||
            !self.checkLowercaseLetter ||
            !self.checkUppercaseLetter ||
            !self.checkNumber ||
            !self.checkSpecialCharacter
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password != self.edit.confirmpassword &&
            self.checkPasswordMatch == false
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t(
                "Password and Confirm Password do not match.Please fill correctly."
              ),
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill all the fields!!!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.changPasswordDialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "saveChangePassword");
      }
    },
  },
};
</script>

<style scoped>
.clear-filters-btn{
  text-transform: none !important;
  padding: 0px 5px;
  font-weight: 600;
}
.border-section-wrapper{
  border-radius: 24px;
  padding: 15px 20px;
  border: 1px solid #CCCCCC;
  transition: all 0.3s ease;
}
.flip-right {
  transform: scaleX(-1);
}
.basic-info-section{
  border-bottom: 1px solid #CCCCCC;
}
.basic-info-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 8px;
}

.basic-info-icon {
  width: 24px;
  height: 24px;
  max-width: 24px;
  max-height: 24px;
  flex-shrink: 0;
  object-fit: contain;
}

.basic-info-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
}

.info-icon {
  margin-left: 4px;
  color: #9e9e9e;
  cursor: pointer;
  vertical-align: middle;
}

.info-icon:hover {
  color: #616161;
}

.tooltip-content {
  text-align: left;
  line-height: 1.5;
}

.tooltip-content div {
  margin-bottom: 2px;
}

.tooltip-content div:last-child {
  margin-bottom: 0;
}


.template-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

/* Page Container */
.user-management-page {
  min-height: 100vh;
  background-color: #f8f9fa;
}

.user-management-container {
  padding: 24px;
}

.vertical-divider {
  width: 1px;
  height: 40px;
  background-color: #ccc;
}

.page-header-section {
  width: 100%;
}

/* Fix skeleton loader to allow proper flex layout */
.skeleton-header-loader {
  width: 100%;
}

.skeleton-header-loader :deep(.v-skeleton-loader__heading) {
  width: 100%;
}

.page-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
}

.page-title-wrapper {
  flex-shrink: 0;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.3;
}

/* Header Action Buttons */
.header-actions-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Template Button - Outlined with coral/orange */
.action-btn-template {
  border-radius: 16px !important ;
  border: 1px solid #C32E0E;
  background: white;
  color: #C32E0E !important;
  font-weight: 600;
  text-transform: none;
  padding: 0 20px !important;
  height: 42px !important;
}

.action-btn-template:hover {
  background: #FDE4DF;
}

/* Import Button - Outlined with coral/orange */
.action-btn-import {
  border: 1px solid #C32E0E !important;
  background: white;
  color: #C32E0E !important;
  font-weight: 600;
  text-transform: none;
  padding: 0 20px !important;
  height: 42px !important;
  border-radius: 16px !important;
}

.action-btn-import:hover {
  background: #FDE4DF;
}

/* Add Button - Gradient background */
.action-btn-add {
  border-radius: 16px !important;
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
  padding: 0 24px !important;
  height: 42px !important;
  box-shadow: 0 4px 12px rgba(243, 98, 67, 0.3) !important;
}

.action-btn-add:hover {
  background: linear-gradient(90deg, #F36243 0%, #FF8E7A 100%) !important;
  box-shadow: 0 6px 16px rgba(243, 98, 67, 0.4) !important;
  transform: translateY(-1px);
}

.btn-label {
  font-size: 0.9rem;
}

.main-content-card {
  border-radius: 16px !important;
  border: 1px solid #DCDCDC !important;
  background: #FFF !important;
  overflow: hidden;
  padding: 20px;
}

.search-panel-section {
  width: 100%;
  padding: 10px 20px;
  border-radius: 16px;
  border: 1px solid var(--placeholder, #CCC);
  margin-bottom: 20px;
}

.search-panel-wrapper {
  width: 100%;
}

.custom-search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  background: transparent;
  height: 100%;
  max-width: unset !important;
}

.custom-search-input-wrapper-full {
  width: 100%;
  flex: 1;
}

/* Search Input Fields */
.search-field-wrapper {
  flex: 0 1 280px;
  min-width: 200px;
}

.search-field-wrapper.username-field,
.search-field-wrapper.email-field {
  flex: 0 1 320px;
}

.search-input-field {
  background: white;
  border-radius: 8px;
}

.search-input-field :deep(.v-field) {
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.search-input-field :deep(.v-field__outline) {
  --v-field-border-opacity: 0.15;
}

.search-input-field :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  border-color: #F36243 !important;
}

.search-input-field :deep(input::placeholder) {
  color: #9e9e9e;
  font-size: 0.9rem;
}

/* Search Button - Circular Gradient */
.search-btn-circular {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  box-shadow: 0 4px 12px rgba(195, 46, 14, 0.3) !important;
  transition: all 0.2s ease;
}

.search-btn-circular:hover {
  box-shadow: 0 6px 16px rgba(195, 46, 14, 0.4) !important;
  transform: scale(1.05);
}

/* Role Filter */
.role-filter-wrapper {
  margin-left: auto;
}

.filter-label {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

.role-count-chip {
  font-weight: 600;
  min-width: 28px;
}

.filter-icon-btn {
  border: 1px solid #e0e0e0;
  border-radius: 8px !important;
}

.filter-icon-btn:hover {
  background-color: #f5f5f5 !important;
}

/* Circular Filter Icon Button */
.filter-icon-btn-circular {
  background: transparent !important;
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

.filter-icon-btn-circular:hover {
  background-color: #FDE4DF !important;
  border: 2px solid #FDE4DF !important;
}

.role-filter-dropdown {
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important;
  overflow: hidden;
}

.role-filter-item {
  min-height: 44px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.modern-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C30000 !important;
}

.role-filter-item:hover {
  background-color: #f5f5f5;
}

.role-filter-item-title {
  font-size: 14px;
  font-weight: 400;
  color: #333;
}

.selected-role-item .role-filter-item-title {
  color: #C32E0E;
  font-weight: 500;
}

.apply-filter-btn {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  color: white !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  border-radius: 20px !important;
  height: 40px !important;
}

.apply-filter-btn:hover {
  opacity: 0.9;
}

.apply-filter-confirm-card {
  border-radius: 16px !important;
}

.apply-filter-confirm-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #171717;
  border-bottom: 1px solid rgba(201, 201, 201, 0.6);
}

.apply-filter-confirm-actions {
  border-top: 1px solid rgba(201, 201, 201, 0.6);
  padding-top: 10px;
}

.apply-filter-confirm-text {
  font-size: 15px !important;
  color: #666;
  line-height: 1.5;
}

.apply-filter-cancel-btn {
  border-radius: 10px !important;
  text-transform: none;
  font-weight: 500;
  min-width: 100px;
  height: 37px !important;
  border-color: #ccc !important;
  color: #333 !important;
}

.apply-filter-cancel-btn:hover {
  background-color: #f5f5f5 !important;
}

.apply-filter-apply-btn {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  color: white !important;
  border-radius: 10px !important;
  text-transform: none;
  font-weight: 500;
  min-width: 100px;
  height: 37px !important;
}

.apply-filter-apply-btn:hover {
  opacity: 0.9;
}

/* Custom Table Styling - matching UploadSoundToDocument.vue */
.customtable {
  border-radius: 16px;
  overflow: hidden;
}

.customtable :deep(thead) {
  background-color: #FFF2F2 !important;
  color: #171717 !important;
  font-weight: 800 !important;
}

.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.customtable :deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span),
.customtable :deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-start .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
.customtable :deep(.mdi-menu-down.mdi.v-icon.notranslate.v-theme--light.v-icon--size-default.v-select__menu-icon) {
  color: #872612;
  opacity: 1 !important;
}

/* Action Container - matching UploadSoundToDocument.vue */
.action-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-group-user {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.action-btn {
  transition: all 0.2s ease;
}

.action-btn.edit-btn:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
}

.action-btn.delete-btn:hover {
  background-color: rgba(244, 67, 54, 0.08) !important;
}

.users-data-table {
  width: 100%;
  background: transparent !important;
}

/* Table Header Styling */
.users-data-table :deep(.v-data-table-header) {
  background-color: #fafafa !important;
}

.users-data-table :deep(.v-data-table-header th) {
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  color: #424242 !important;
  text-transform: none !important;
  padding: 16px 12px !important;
  border-bottom: 1px solid #e8e8e8 !important;
}

/* Table Rows */
.table-row {
  transition: background-color 0.15s ease;
}

.table-row:hover {
  background-color: #fafafa !important;
}

/* Table Cells */
.table-cell {
  padding: 14px 12px !important;
  font-size: 0.9rem;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}

.cell-number {
  color: #666;
  font-weight: 500;
}

.cell-username {
  font-weight: 500;
  color: #1a1a1a;
}

.cell-email {
  color: #555;
}

.cell-phone {
  color: #555;
}

.cell-name {
  color: #333;
}

.cell-role {
  color: #555;
}

/* Action Buttons in Table */
.actions-wrapper {
  gap: 4px;
}

.action-icon-btn {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
}

.edit-action-btn:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
}

.delete-action-btn:hover {
  background-color: rgba(244, 67, 54, 0.08) !important;
}

@media (max-width: 960px) {
  .page-header-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .header-actions-group {
    width: 100%;
    justify-content: flex-end;
    margin-top: 16px;
  }

  .search-panel-wrapper {
    flex-direction: column;
  }

  .search-field-wrapper {
    width: 100%;
    flex: 1 1 100%;
  }

  .role-filter-wrapper {
    width: 100%;
    justify-content: flex-end;
    margin-top: 12px;
  }
}

@media (max-width: 600px) {
  .user-management-container {
    padding: 16px !important;
  }

  .page-title {
    font-size: 1.25rem;
  }

  .header-actions-group {
    gap: 8px !important;
  }

  .action-btn-template,
  .action-btn-import,
  .action-btn-add {
    padding: 0 12px !important;
    height: 38px !important;
  }

  .btn-label {
    font-size: 0.8rem;
  }
}

/* ============================================ */
/* Base Card Styles */
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.title {
  color: white;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.ChangePassword:hover {
  background-color: #1976d2 !important;
  color: white !important;
}

/* Common Dialog Styles */
.template-dialog,
.add-user-dialog,
.edit-user-dialog,
.change-password-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideInDown 0.3s ease-out;
}

/* Common Header Styles */
/* .template-header,
.add-user-header,
.edit-user-header,
.change-password-header {
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.template-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.add-user-header {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
} */

/* .edit-user-header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
} */

/* .change-password-header {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
} */

/* Common Header Content */
/* .header-content {
  display: flex;
  align-items: center;
  gap: 16px;
} */

/* .header-icon {
  font-size: 28px;
  opacity: 0.9;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

*/
.dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
  color: black;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: gray;
}

/* 


.close-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
} */

/* Common Content Styles */
.template-content,
.add-user-content,
.edit-user-content,
.change-password-content {
  padding: 20px;
  background-color: white;
  /**fafafa */
}

/* File Format Section Styles */
.file-format-section {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
}

.file-format-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.file-format-icon {
  width: 24px;
  height: 24px;
}

.file-format-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.file-format-cards {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.file-format-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 5px;
  background: #ffffff;
  border: 2px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.file-format-card:hover {
  background: #fff9f8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(195, 46, 14, 0.15);
}

.file-format-card:focus {
  outline: 2px solid #c32e0e;
  outline-offset: 2px;
}

.file-icon-wrapper {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

}

.csv-icon-bg {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
}

.excel-icon-bg {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
}

.file-type-icon {
  width: 50px;
  height: 46px;
  object-fit: contain;
}

.file-type-label {
  font-size: 0.95rem;
  font-weight: 500;
  color: #171717;
}

.add-user-content,
.edit-user-content,
.change-password-content {
  max-height: 70vh;
  overflow-y: auto;
}

.change-password-content {
  contain: layout;
}

/* Form Sections */
.form-section {
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 15px;
  padding-bottom: 8px;
  /* border-bottom: 2px solid rgba(var(--v-theme-primary), 0.1); */
}
.section-title-password {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 16px;
  padding-bottom: 8px;
}
.image-icon-style {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}

.password-toggle-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.section-divider {
  margin: 20px 0;
  opacity: 0.6;
}

.form-row {
  margin-bottom: 8px;
}

.form-row .v-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Input Styling */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  min-height: 60px;
}

.input-error-state .input-label {
  color: #d32f2f;
}

.input-error-state .input-label .required-asterisk {
  color: #d32f2f;
}

.input-wrapper:has(.password-requirements) {
  min-height: 200px;
}

.input-wrapper:has(.password-match) {
  min-height: 120px;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
}

/* .input-label .required-asterisk {
  color: #f44336;
  margin-left: 2px;
} */

.modern-input :deep(.v-field) {
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.change-password-content .modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.15);
}

.change-password-content .modern-input :deep(.v-field--focused .v-field__outline) {
  border-color: #ff9800;
}

.modern-input :deep(.v-field__outline) {
  --v-field-border-opacity: 0.25;
}

.modern-input :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

.modern-input :deep(.v-field--error:not(.v-field--disabled)) {
  box-shadow: 0 0 0 1px rgba(211, 47, 47, 0.18);
}

.modern-input :deep(.v-field--error:not(.v-field--disabled) .v-field__outline__start),
.modern-input :deep(.v-field--error:not(.v-field--disabled) .v-field__outline__end),
.modern-input :deep(.v-field--error:not(.v-field--disabled) .v-field__outline__notch) {
  border-color: #d32f2f !important;
}

.help-icon {
  color: rgba(var(--v-theme-primary), 0.7);
  cursor: help;
  transition: color 0.2s ease;
}

.help-icon:hover {
  color: rgb(var(--v-theme-primary));
}

.password-toggle {
  margin: 0 !important;
}

/* Password Requirements */
.password-requirements,
.password-match {
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.password-requirements {
  padding: 12px;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.password-match {
  padding: 8px 12px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.password-match .requirement-item {
  width: 100%;
}

.requirement-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  margin: 4px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 4px 6px;
  border-radius: 6px;
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInRequirement 0.4s ease-out forwards;
}

.requirement-item:nth-child(1) {
  animation-delay: 0.1s;
}

.requirement-item:nth-child(2) {
  animation-delay: 0.15s;
}

.requirement-item:nth-child(3) {
  animation-delay: 0.2s;
}

.requirement-item:nth-child(4) {
  animation-delay: 0.25s;
}

.requirement-item:nth-child(5) {
  animation-delay: 0.3s;
}

.requirement-item.valid {
  color: #2ABF56 !important;
  background: rgba(42, 191, 86, 0.10) !important;
  border: 1px solid rgba(42, 191, 86, 0.25) !important;
}

.requirement-item:not(.valid) {
  color: #C30000 !important;
  border: 1px solid rgba(195, 0, 0, 0.25) !important;
  background: rgba(195, 0, 0, 0.10) !important;
}

/* Password Strength Indicator */
.password-strength-wrapper {
  background: white;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.strength-label {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: rgb(var(--v-theme-on-surface));
  transition: all 0.3s ease;
}

.strength-text {
  font-weight: 700;
  margin-left: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

.strength-bar {
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.strength-bar :deep(.v-progress-linear__background) {
  background-color: rgba(var(--v-border-color), 0.15) !important;
  transition: all 0.3s ease;
}

.strength-bar :deep(.v-progress-linear__determinate) {
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.strength-bar :deep(.v-progress-linear__determinate)::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent);
  animation: shimmer 2s infinite;
}

/* Role Selection */
.role-selection-container-compact {
  background: white;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.role-radio-group-compact {
  margin: 0;
}

.role-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
}

.role-card-compact {
  position: relative;
  background: #f8f9fa;
  border: 1.5px solid rgba(var(--v-border-color), 0.2);
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.role-card-compact:hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
  background: rgba(var(--v-theme-primary), 0.03);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.12);
}

.role-card-compact.selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.08);
  box-shadow: 0 2px 12px rgba(var(--v-theme-primary), 0.2);
}

.role-card-compact.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #e0e0e0 !important;
  border-color: #bdbdbd !important;
}

.role-card-compact.disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  border-color: #bdbdbd !important;
  background: #e0e0e0 !important;
}

.role-badge {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}

.role-icon-compact {
  font-size: 20px !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.role-radio-compact {
  margin: 0;
  padding: 0;
}

.role-radio-compact :deep(.v-selection-control) {
  min-height: auto;
  margin: 0;
}

.role-radio-compact :deep(.v-selection-control__wrapper) {
  height: 16px;
  width: 16px;
}

.role-details {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column-reverse;
}

.role-title-compact {
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;
  color: rgb(var(--v-theme-on-surface));
  line-height: 1.2;
  text-align: center;
}

.role-chip {
  align-self: center;
  height: 25px !important;
}

/* Role Card Colors */
.role-card-compact:nth-child(1):hover {
  border-color: rgba(244, 67, 54, 0.4);
  background: rgba(244, 67, 54, 0.03);
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.12);
}

.role-card-compact:nth-child(1).selected {
  border-color: #f44336;
  background: rgba(244, 67, 54, 0.08);
  box-shadow: 0 2px 12px rgba(244, 67, 54, 0.2);
}

.role-card-compact:nth-child(2):hover {
  border-color: rgba(255, 152, 0, 0.4);
  background: rgba(255, 152, 0, 0.03);
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.12);
}

.role-card-compact:nth-child(2).selected {
  border-color: #ff9800;
  background: rgba(255, 152, 0, 0.08);
  box-shadow: 0 2px 12px rgba(255, 152, 0, 0.2);
}

.role-card-compact:nth-child(3):hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
  background: rgba(var(--v-theme-primary), 0.03);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.12);
}

.role-card-compact:nth-child(3).selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.08);
  box-shadow: 0 2px 12px rgba(var(--v-theme-primary), 0.2);
}

.role-card-compact:nth-child(4):hover {
  border-color: rgba(156, 39, 176, 0.4);
  background: rgba(156, 39, 176, 0.03);
  box-shadow: 0 2px 8px rgba(156, 39, 176, 0.12);
}

.role-card-compact:nth-child(4).selected {
  border-color: #9c27b0;
  background: rgba(156, 39, 176, 0.08);
  box-shadow: 0 2px 12px rgba(156, 39, 176, 0.2);
}

/* New Role Selection Styles */
.role-permissions-wrapper {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #C9C9C9;
  padding: 16px;
  transition: all 0.3s ease;
}

.role-selection-container-new {
  background: transparent;
}

.role-radio-group-new {
  margin: 0;
}

.role-cards-grid-new {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.role-card-new {
  position: relative;
  background: #fff;
  border: 1px solid #FFDED8;
  border-radius: 16px;
  padding: 16px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-height: 100px;
}

.role-card-new:hover {
  background: #FFF2F2;
}

.role-card-new.selected {
  background: #FFF2F2;
  border-color: #FFDED8;
}

.role-card-new.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f5f5f5 !important;
  border-color: #e0e0e0 !important;
}

.role-card-new.disabled:hover {
  background: #f5f5f5 !important;
}

.role-card-checkbox {
  position: absolute;
  top: 8px;
  left: 8px;
}

.role-radio-new {
  margin: 0;
  padding: 0;
}

.role-radio-new :deep(.v-selection-control) {
  min-height: auto;
  margin: 0;
}

.role-radio-new :deep(.v-selection-control__wrapper) {
  height: 18px;
  width: 18px;
}

.role-radio-new :deep(.v-selection-control__input > .v-icon) {
  font-size: 18px;
  color: #F44336;
}

.role-card-new.selected .role-radio-new :deep(.v-selection-control__input > .v-icon) {
  color: #F44336;
}

.role-card-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}

.role-icon-svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.role-card-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
  text-align: center;
}

/* Role Autocomplete Styles - Red dropdown icon */
.role-autocomplete :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
  font-size: 24px !important;
}

.role-autocomplete :deep(.v-field__clearable .v-icon) {
  color: #872612 !important;
}

/* Account Status Container Styles */
.account-status-container {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: #fff;
  border: 1px solid rgba(var(--v-border-color), 0.2);
  border-radius: 16px;
  padding: 12px 16px;
  margin-top: 24px;
}

/* Account Status - Left side */
.account-status-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.account-status-label-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.account-status-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
}

.account-status-description {
  font-size: 0.8rem;
  color: #666;
}

/* Account Status - Right side */
.account-status-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.account-status-chip {
  min-width: 80px;
  min-height: 28px !important;
  justify-content: center;
  margin-top: 5px;
}

/* Switch Wrapper */
.switch-wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
}

.switch-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg,
      rgba(var(--v-theme-success), 0.3) 0%,
      rgba(var(--v-theme-success), 0.1) 100%);
  transition: all 0.3s ease;
}

.switch-wrapper:has(.modern-switch input:checked)::before {
  background: linear-gradient(90deg,
      rgba(var(--v-theme-error), 0.3) 0%,
      rgba(var(--v-theme-error), 0.1) 100%);
}

.switch-wrapper:has(.modern-switch input:checked) {
  box-shadow: 0 2px 16px rgba(var(--v-theme-error), 0.1);
}

.switch-wrapper:has(.modern-switch input:not(:checked)) {
  box-shadow: 0 2px 16px rgba(var(--v-theme-success), 0.1);
}

.switch-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.switch-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.lock-icon-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(170, 213, 157, 0.242) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.lock-icon-container:has(.locked) {
  background: rgba(156, 61, 61, 0.242) !important;
}

.lock-icon {
  font-size: 24px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.lock-icon.locked {
  animation: lockShake 0.6s ease-in-out;
  transform-origin: center;
}

.lock-icon.unlocked {
  animation: unlockBounce 0.8s ease-out;
  transform-origin: center;
}

.switch-title {
  font-size: 1rem;
  font-weight: 700;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 4px;
  transition: color 0.3s ease;
}

.switch-subtitle {
  font-size: 0.85rem;
  color: rgba(var(--v-theme-on-surface), 0.7);
  margin-top: 2px;
  line-height: 1.4;
  max-width: 300px;
  transition: color 0.3s ease;
}

.switch-control {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}

.switch-label {
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 6px;
  margin-left: 8px;
}

.switch-label.locked-text {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
}

.switch-label.unlocked-text {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
}

/* Model Autocomplete */
:deep(.model-all-option) {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 10px 14px !important;
  border-radius: 12px !important;
  cursor: pointer !important;
  transition: background 0.2s ease, border 0.2s ease, box-shadow 0.2s ease !important;
  width: 100% !important;
}

:deep(.model-all-option .v-list-item__content) {
  display: flex !important;
  align-items: center !important;
}
.filter-role-list .v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {
  padding: 0px 15px !important;
}

.v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {
  padding: 5px !important;
}
.v-list-item--density-compact:not(.v-list-item--nav).v-list-item--one-line {
    padding-inline: 5px !important;
}

:deep(.model-all-title) {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
}

:deep(.model-all-option--active) {
  background: rgba(195, 0, 0, 0.08);
  border: 1px solid rgba(195, 0, 0, 0.3);
  box-shadow: 0 2px 8px rgba(195, 0, 0, 0.12);
}

:deep(.model-all-option--disabled) {
  opacity: 0.5;
  cursor: not-allowed;
}

:deep(.model-all-option__label) {
  white-space: nowrap !important;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
}

.model-all-divider {
  width: 100% !important;
  border-color: #CCCCCC !important;
  height: 2px !important;
  opacity: 1 !important;
}

.model-option-item {
  border-radius: 10px;
  transition: background 0.2s ease, border 0.2s ease;
}

:deep(.model-option-item--selected) {
  background: rgba(195, 0, 0, 0.08);
  border: 1px solid rgba(195, 0, 0, 0.25);
}

:deep(.model-option-checkbox) {
  margin-right: 8px;
}

:deep(.model-option-checkbox .v-selection-control__input) {
  width: 20px;
  height: 20px;
}

:deep(.model-option-title) {
  font-weight: 500;
}

:deep(.model-info-icon) {
  color: rgba(var(--v-theme-on-surface), 0.6);
  cursor: pointer;
  transition: color 0.2s ease;
}

:deep(.model-info-icon:hover) {
  color: #C30000;
}

.model-all-selected-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #C30000;
  padding: 6px 12px;
  border-radius: 16px;
  background-color: rgba(195, 0, 0, 0.08);
  white-space: nowrap;
  flex-shrink: 0;
}

/* Fix autocomplete selection container when showing "All Model" */
.model-autocomplete :deep(.v-autocomplete__selection) {
  max-width: 100%;
  overflow: visible;
}

/* Hide empty selection containers (when all models selected and index > 0) */
.model-autocomplete :deep(.v-autocomplete__selection:empty) {
  display: none !important;
}

.more-chip {
  /* background-color: #F9EBE7 !important; */
  color: #C30000 !important;
  font-weight: 500;
  border: 1px solid #C30000 !important;
}

.model-chip {
  border: 1px solid #C30000 !important;
  /* background: #F9EBE7 !important; */
  color: #C30000 !important;
  border-radius: 999px !important;
  font-weight: 500;
  margin: 2px 4px 2px 0;
  padding: 0 8px !important;
}

.model-chip :deep(.v-icon) {
  color: #C30000 !important;
  opacity: 0.7;
  font-size: 16px !important;
}

.model-chip :deep(.v-icon:hover) {
  opacity: 1;
}

/* Global chip styles for all role-autocomplete fields */
.role-autocomplete :deep(.v-chip) {
  border: 1px solid #C30000 !important;
  /* background-color: #FFF2F2 !important; rgba(195, 0, 0, 0.08) !important; */
  color: #C30000 !important;
  border-radius: 999px !important;
  font-weight: 500;
  font-size: 0.8125rem;
  padding: 0 4px 0 12px !important;
}

.role-autocomplete :deep(.v-chip .v-chip__content) {
  color: #C30000 !important;
}

/* Custom close button with | x style */
.role-autocomplete :deep(.v-chip .v-chip__close) {
  display: flex;
  align-items: center;
  padding: 0px 8px 0px 4px;
  border-left: 1px solid #646464;
  color: #646464 !important;
  opacity: 0.6;
  font-size: 14px !important;
  width: auto !important;
  height: 100%;
}

.role-autocomplete :deep(.v-chip .v-chip__close:hover) {
  opacity: 1;
}

/* Hide the default icon and show × character */
.role-autocomplete :deep(.v-chip .v-chip__close .v-icon) {
  font-size: 14px !important;
}

.role-autocomplete :deep(.v-chip--closable) {
  padding-right: 8px !important;
}

.all-model-chip {
  padding-right: 10px !important;
}

/* Custom chip with | x close button */
.custom-chip {
  display: inline-flex !important;
  align-items: center !important;
  gap: 0 !important;
  padding-right: 0 !important;
}

.custom-chip :deep(.v-chip__close) {
  display: none !important;
}

.chip-close-divider {
  color: #888888;
  margin: 0 6px 0 8px;
  font-weight: 300;
  font-size: 14px;
}

.chip-close-x {
  color: #888888;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding-right: 8px;
  transition: color 0.15s ease;
}

.chip-close-x:hover {
  color: #555555;
}

.chip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #C30000;
  display: inline-block;
  margin-right: 6px;
}

/* Template Table */
/* .template-table-wrapper {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
} */

.template-table {
  background: white;
}

.template-table :deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

.template-table :deep(.v-data-table-header) {
  background-color: #f5f5f5;
}

.template-table :deep(.v-data-table-header th) {
  font-weight: 600;
  color: #424242;
  font-size: 0.875rem;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.template-row {
  transition: background-color 0.2s ease;
}

.template-row:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.download-cell {
  text-align: center;
  padding: 16px 12px;
}

.download-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 8px;
  min-width: 100px;
  height: 36px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Security Tips */
.security-tips-style {
  margin-bottom: 15px;
  animation: fadeInUp 0.5s ease-out 0.3s both;
}

.security-alert {
  border-radius: 12px;
  border: 1px solid rgba(var(--v-theme-info), 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.security-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.15);
}

.alert-content {
  font-size: 0.875rem;
}

.template-description {
  color: #171717;
  display: flex;
  padding: 15px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-radius: 16px;
  border: 1px solid #C9C9C9;
  background: linear-gradient(90deg, #FFF2F2 -15.8%, #FFFFFF 100%);
}

.tips-list {
  margin: 8px 0 0 16px;
  padding: 0;
}

.tips-list li {
  margin: 4px 0;
  line-height: 1.4;
  color: rgba(var(--v-theme-on-surface), 0.8);
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInTip 0.4s ease-out forwards;
}

.tips-list li:nth-child(1) {
  animation-delay: 0.9s;
}

.tips-list li:nth-child(2) {
  animation-delay: 1s;
}

.tips-list li:nth-child(3) {
  animation-delay: 1.1s;
}

.tips-list li:nth-child(4) {
  animation-delay: 1.2s;
}

/* Action Buttons */
.template-actions,
.add-user-actions,
.edit-user-actions,
.change-password-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.edit-user-actions {
  display: flex;
  align-items: center;
}

/* .dialog-action-btn, */
.close-dialog-action-btn,
.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  height: 44px;
  min-width: 120px;
  transition: all 0.2s ease;
}

.close-dialog-action-btn {
  padding: 0 24px;
  height: 40px;
}

/* .dialog-action-btn {
  padding: 0 20px;
  height: 40px;
  min-width: 140px;
} */

.cancel-btn,
.save-btn {
  padding: 0 24px;
}

.cancel-btn:hover,
.close-dialog-action-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
  transform: translateY(-1px);
}

/* .dialog-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
} */

.save-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.add-user-actions .save-btn {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.add-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

@media (max-width: 768px) {
  .add-user-actions {
    flex-direction: column;
    align-items: center;
  }
}

.edit-user-actions .save-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.edit-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
}

.change-password-actions .save-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

.change-password-actions .save-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

.change-password-actions .save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Animations */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRequirement {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInTip {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@keyframes lockShake {

  0%,
  100% {
    transform: translateX(0) scale(1);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-2px) scale(1.05);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translateX(2px) scale(1.05);
  }
}

@keyframes unlockBounce {
  0% {
    transform: scale(1) rotate(0deg);
  }

  20% {
    transform: scale(1.2) rotate(-5deg);
  }

  40% {
    transform: scale(1.1) rotate(5deg);
  }

  60% {
    transform: scale(1.15) rotate(-3deg);
  }

  80% {
    transform: scale(1.05) rotate(2deg);
  }

  100% {
    transform: scale(1) rotate(0deg);
  }
}

/* Vue Transitions */
.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
  filter: blur(2px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px) scale(0.98);
  filter: blur(1px);
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
  filter: blur(0);
}

.expand-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-enter-from {
  opacity: 0;
  transform: translateY(-15px) scaleY(0.8);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px) scaleY(0.9);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-enter-to,
.expand-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scaleY(1);
  max-height: 200px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {

  /* Dialog sizes */
  .template-dialog,
  .add-user-dialog,
  .edit-user-dialog,
  .change-password-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  /* Headers */
  .template-header,
  .add-user-header,
  .edit-user-header,
  .change-password-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 24px;
  }

  /* .dialog-title {
    font-size: 1.25rem;
  } */

  /* Content */
  .template-content,
  .add-user-content,
  .edit-user-content,
  .change-password-content {
    padding: 16px;
  }

  .add-user-content,
  .edit-user-content,
  .change-password-content {
    max-height: 60vh;
  }

  /* Role cards */
  .role-cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .role-card-compact {
    padding: 8px;
    min-height: 60px;
  }

  .role-icon-compact {
    font-size: 18px !important;
  }

  .role-title-compact {
    font-size: 0.8rem;
  }

  /* Switch */
  .switch-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .switch-control {
    align-items: flex-start;
    width: 100%;
  }

  .lock-icon-container {
    width: 40px;
    height: 40px;
  }

  .lock-icon {
    font-size: 20px !important;
  }

  .switch-title {
    font-size: 0.9rem;
  }

  .switch-subtitle {
    font-size: 0.8rem;
    max-width: none;
  }

  /* Password */
  .password-requirements {
    min-height: 100px;
    padding: 10px;
  }

  .password-strength-wrapper {
    min-height: 70px;
    padding: 12px;
  }

  .input-wrapper:has(.password-requirements) {
    min-height: 180px;
  }

  .input-wrapper:has(.password-match) {
    min-height: 100px;
  }

  .requirement-item {
    font-size: 0.75rem;
    padding: 3px 5px;
  }

  .strength-label {
    font-size: 0.8rem;
  }

  /* Buttons */
  /* .dialog-action-btn, */
  .cancel-btn,
  .save-btn {
    min-width: 100px;
    height: 40px;
  }

  .edit-user-actions {
    flex-direction: column;
    gap: 8px;
  }

  .dialog-action-btn {
    width: 100%;
    order: 1;
  }

  .cancel-btn {
    width: 100%;
    order: 2;
  }

  .save-btn {
    width: 100%;
    order: 3;
  }

  /* Template */
  .download-btn {
    font-size: 0.8rem;
    min-width: 90px;
    height: 32px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .download-cell {
    padding: 12px 8px;
  }

  .tips-list {
    font-size: 0.8rem;
  }

  /* Animations */
  .slide-fade-enter-active,
  .expand-fade-enter-active {
    transition-duration: 0.3s;
  }

  .requirement-item {
    animation-duration: 0.3s;
  }
}

@media (max-width: 480px) {

  /* Dialog sizes */
  .template-dialog,
  .add-user-dialog,
  .edit-user-dialog,
  .change-password-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  /* Headers */
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  /* Role cards */
  .role-selection-container-compact {
    padding: 8px;
  }

  .role-cards-grid {
    grid-template-columns: 1fr 1fr;
    gap: 4px;
  }

  .role-card-compact {
    padding: 6px;
    min-height: 55px;
  }

  .role-icon-compact {
    font-size: 16px !important;
  }

  .role-title-compact {
    font-size: 0.75rem;
  }

  /* New Role Cards */
  .role-cards-grid-new {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .role-card-new {
    padding: 12px 8px;
    min-height: 80px;
  }

  .role-card-icon {
    width: 32px;
    height: 32px;
  }

  .role-card-label {
    font-size: 0.75rem;
  }

  /* Switch */
  .switch-wrapper {
    padding: 16px;
  }

  .switch-info {
    gap: 12px;
  }

  .lock-icon-container {
    width: 36px;
    height: 36px;
  }

  .lock-icon {
    font-size: 18px !important;
  }

  .switch-title {
    font-size: 0.85rem;
  }

  .switch-subtitle {
    font-size: 0.75rem;
  }

  .switch-label {
    font-size: 0.8rem;
  }

  /* Password */
  .password-requirements {
    min-height: 90px;
    padding: 8px;
  }

  .password-strength-wrapper {
    min-height: 60px;
    padding: 10px;
  }

  .input-wrapper:has(.password-requirements) {
    min-height: 160px;
  }

  .input-wrapper:has(.password-match) {
    min-height: 90px;
  }

  /* Buttons */
  .add-user-actions,
  .change-password-actions {
    flex-direction: column;
    gap: 8px;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
  }

  .dialog-action-btn,
  .cancel-btn,
  .save-btn {
    height: 40px;
    font-size: 0.9rem;
  }

  /* Others */
  .section-title {
    font-size: 1rem;
  }

  .download-btn {
    font-size: 0.75rem;
    min-width: 80px;
    height: 30px;
  }
}

/* Accessibility and Performance */
.role-card-compact:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 1px;
}

.modern-switch:focus-within .lock-icon-container {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.change-password-dialog :deep(.v-btn:focus-visible) {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.switch-wrapper:hover .lock-icon-container {
  transform: scale(1.05);
}

.switch-wrapper:active .lock-icon-container {
  transform: scale(0.95);
}

.switch-wrapper:active .lock-icon {
  transform: scale(0.9);
}

/* Reduce Motion for Accessibility */
@media (prefers-reduced-motion: reduce) {

  .slide-fade-enter-active,
  .slide-fade-leave-active,
  .expand-fade-enter-active,
  .expand-fade-leave-active,
  .requirement-item,
  .strength-bar :deep(.v-progress-linear__determinate),
  .security-tips-style,
  .tips-list li {
    animation: none;
    transition: none;
  }

  .requirement-item,
  .tips-list li {
    opacity: 1;
    transform: none;
  }
}

/* Hidden/Unused Styles */
.role-selection-container,
.role-radio-group,
.role-card {
  display: none;
}

.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 300px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.control-btn {
  margin: 0 4px;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.template-btn,
.import-btn {
  width: 120px;
  height: 36px;
}

.template-btn:hover {
  background: transparent !important;
  box-shadow: none;
  transform: translate(0);
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}
</style>